<template>
  <div class="common">
    <!-- 登录 -->
    <!-- 聊天 -->
    <el-container>
      <el-aside width="225px">
        <my-aside :reLoadAsideFlag="reLoadAsideFlag"/>
      </el-aside>
      <el-container v-show="msgList">
        <header class="chatHeader flexBox">
          <!-- <span v-if="userInfo.name == '默认群聊'"
            >{{ userInfo.name }}： {{ userList.length - 1 }}</span
          > -->
          <div>{{ userInfo && userInfo.name ? userInfo.name : '' }}</div>
          <div>
            <el-button type="success" size="medium" v-if="userInfo.startTime === null" @click="StartOrOver(userInfo)">接诊
            </el-button>
            <el-button type="danger" size="medium" v-if="userInfo.startTime !== null" @click="refusePre(userInfo)">驳回
            </el-button>
            <el-button type="danger" size="medium" v-if="userInfo.startTime !== null"
                       @click="StartOrOver(userInfo)">结束问诊
            </el-button>

          </div>
        </header>
        <el-main class="el-main" ref="elmain">
          <my-main :recordFlag="recordFlag" ref="mymain"/>
        </el-main>
        <el-footer class="chat-footer" ref="chatFooter">
          <!-- 拖拽区域 -->
          <div class="drag-handle"></div>
          <my-footer :has-dialog-visible="hasDialogVisible"/>
        </el-footer>
      </el-container>
      <el-dialog :visible.sync="refundVisible" width="442px" class="eventDialog" style="top: -25%">
        <h1 style="text-align: center; margin-bottom: 22px; color: #0caf60">
          驳回
        </h1>
        <el-form :model="refundForm" :rules="rules" ref="refundForm" label-width="100px" class="demo-ruleForm"
                 style="padding-right: 22px">
          <el-form-item label="驳回原因" prop="reasonCode">
            <el-select v-model="refundForm.reasonCode" placeholder="请选择驳回原因" style="width: 100%">
              <el-option label="主诉与用药不符" value="主诉与用药不符"></el-option>
              <el-option label="诊断与用药不符" value="诊断与用药不符"></el-option>
              <el-option label="用药总量超量" value="用药总量超量"></el-option>
              <el-option label="年龄与用药不符" value="年龄与用药不符"></el-option>
              <el-option label="性别与用药不符" value="性别与用药不符"></el-option>
              <el-option label="其他" value="其他"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="驳回说明" prop="desc">
            <el-input type="textarea" v-model="refundForm.desc" class="textareaStyle" resize="none"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="refundVisible = false" type="success" plain>取 消
          </el-button>
          <div v-loading="buttonLoading" style="display: inline-block; margin-left: 20px">
            <el-button type="success" @click="refundEvent" class="confirmButton">确 定
            </el-button>
          </div>
        </div>
      </el-dialog>
      <el-dialog title="开方" :visible.sync="pre_FLag" width="80%" v-loading="loading3" class="PRE_box"
                 :close-on-click-modal="false">
        <div class="rightBox">
          <div class="rightBoxMain">
            <el-form ref="form" :model="form" label-width="80px" @submit.native.prevent>
              <el-form-item label="医疗类别" style="margin-bottom: 12px">
                <button type="button" class="opsp_button" @click="opspReg">+ 慢特病</button>
                <el-select :style="diseFlag" v-model="diseName" filterable placeholder="请选择慢特病"
                           @visible-change="clearDiseOptions" ref="diseClearValue" style="margin-left: 10px">
                  <el-option v-for="item in diseOptions" :key="`${item.diseCode}-${item.expContent}`" 
                              :value="JSON.stringify(item)" :label="`${item.diseName} ${item.expContent == 11 ? '门诊慢病' : '门诊特病'}`">
                     <template #default>
                       {{ item.diseName }}
                       <span style="color: red; margin-left: 5px;">
                         {{ item.expContent == 11 ? '门诊慢病' : '门诊特病' }}
                       </span>
                     </template>
                   </el-option>
                </el-select>
                <!-- 显示回显的慢特病信息 -->
                <div v-if="opspEchoInfo" style="margin-left: 10px; padding: 5px 10px; background-color: #f5f7fa; border-radius: 4px; display: inline-block;">
                  {{ opspEchoInfo.diseName }}
                  <span style="color: red; margin-left: 5px;">
                    {{ opspEchoInfo.expContent == 11 ? '门诊慢病' : '门诊特病' }}
                  </span>
                </div>
                <button type="button" class="in_hospital_button" @click="inhosp"
                        :style="inHospFlag ? 'background: rgb(250, 176, 29)' : 'background: #dadada'">+ 住院期间
                </button>
                <div style="text-align: center;display: inline-block;margin-left: 200px">
                  线下就诊凭证：
                  <button type="button" class="opsp_button" @click="queryPsn" v-loading="loading4">读取电子凭证</button>
                </div>
              </el-form-item>

              <el-form-item label="处方类别" style="margin-bottom: 12px">
                <div style="display: flex; align-items: flex-start; gap: 20px;">
                  <el-select disabled v-model="rxTypeCode" placeholder="请选择" @change="onRxTypeChange">
                    <el-option v-for="item in RxType" :key="`rxType_${item.value}`" :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>

                  <div v-if="isTraditionalChineseMedicine"
                       style="display: flex; align-items: center; gap: 12px; flex-wrap: wrap; margin-top: 8px;">

                    <div style="display: flex; align-items: center; gap: 6px;">
                      <span
                          style="font-weight: 500; font-size: 13px; width: 60px; text-align: right; white-space: nowrap;">用药数量：</span>
                      <el-select v-model="num" placeholder="请选择或输入用药数量" style="width: 100px;" size="small"
                                 @change="calculateTotalPrice" filterable allow-create>
                        <el-option v-for="item in chineseMedicineDosesOptions" :key="`doses_${item.value}`"
                                   :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </div>

                    <div style="display: flex; align-items: center; gap: 6px;">
                      <span
                          style="font-weight: 500; font-size: 13px; width: 60px; text-align: right; white-space: nowrap;">煎药方式：</span>
                      <el-select v-model="decoctingMethod" placeholder="请选择煎药方式" style="width: 100px;"
                                 size="small">
                        <el-option v-for="item in decoctingMethodOptions" :key="`decocting_${item.value}`"
                                   :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </div>

                    <div style="display: flex; align-items: center; gap: 6px;">
                      <span
                          style="font-weight: 500; font-size: 13px; width: 60px; text-align: right; white-space: nowrap;">用法名称：</span>
                      <el-select v-model="wayName" placeholder="请选择用法" style="width: 100px;" size="small">
                        <el-option v-for="item in wayNameOptions" :key="`wayName_${item.value}`" :label="item.label"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </div>

                    <div style="display: flex; align-items: center; gap: 6px;">
                      <span
                          style="font-weight: 500; font-size: 13px; width: 60px; text-align: right; white-space: nowrap;">频次名称：</span>
                      <el-select v-model="frquName" placeholder="请选择频次" style="width: 150px;" size="small">
                        <el-option v-for="item in frquNameOptions" :key="`frquName_${item.value}`" :label="item.label"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </div>

                    <!-- 每日剂数和每剂次数字段隐藏，绑定用于后端传递 -->
                    <div style="display: none;">
                      <el-select v-model="frquNum" placeholder="请选择剂数" style="width: 100px;" size="small">
                        <el-option v-for="(item, index) in frquNumOptions" :key="index" :label="item.label"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </div>

                    <div style="display: none;">
                      <el-select v-model="frquPreNum" placeholder="请选择次数" style="width: 100px;" size="small">
                        <el-option v-for="item in frquPreNumOptions" :key="`frquPreNum_${item.value}`"
                                   :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </div>

                    <div style="display: flex; align-items: center; gap: 6px;">
                      <span
                          style="font-weight: 500; font-size: 13px; width: 60px; text-align: right; white-space: nowrap;">单次用量：</span>
                      <el-select v-model="sinDoscnt" placeholder="请选择用量" style="width: 100px;"
                                 size="small">
                        <el-option label="50" value="50"></el-option>
                        <el-option label="100" value="100"></el-option>
                        <el-option label="150" value="150"></el-option>
                        <el-option label="200" value="200"></el-option>
                      </el-select>
                      <el-select v-model="sinDosunt" placeholder="请选择单位" style="width: 100px;" size="small">
                        <el-option v-for="item in tcmSinDosuntOptions" :key="`tcmSinDosunt_${item.value}`"
                                   :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </div>

                    <div style="display: flex; align-items: center; gap: 6px;">
                      <span
                          style="font-weight: 500; font-size: 13px; width: 60px; text-align: right; white-space: nowrap;">用药时间：</span>
                      <el-select v-model="usageTime" placeholder="请选择时间" style="width: 120px;" size="small">
                        <el-option v-for="item in usageTimeOptions" :key="`usageTime_${item.value}`" :label="item.label"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </div>

                    <div style="display: flex; align-items: center; gap: 6px;">
                      <span
                          style="font-weight: 500; font-size: 13px; width: 60px; text-align: right; white-space: nowrap;">中药剂型：</span>
                      <el-select v-model="drugType" placeholder="请选择中药剂型" style="width: 100px;" size="small">
                        <el-option v-for="item in drugTypeOptions" :key="`drugType_${item.value}`" :label="item.label"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </div>


                    <div style="display: flex; align-items: center; gap: 6px;">
                      <span
                          style="font-weight: 500; font-size: 13px; width: 60px; text-align: right; white-space: nowrap;">单副金额：</span>
                      <span
                          style="color: #0caf60; font-weight: bold; font-size: 14px; width: 100px; text-align: left;">￥{{
                          (chineseMedicineSinglePrice || 0).toFixed(2)
                        }}</span>
                    </div>

                    <div style="display: flex; align-items: center; gap: 6px;">
                      <span
                          style="font-weight: 500; font-size: 13px; width: 60px; text-align: right; white-space: nowrap;">总计金额：</span>
                      <span
                          style="color: #0caf60; font-weight: bold; font-size: 14px; width: 100px; text-align: left;">￥{{
                          (chineseMedicineTotalPrice || 0).toFixed(2)
                        }}</span>
                    </div>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="注意事项" style="margin-bottom: 12px">
                <div class="rightBoxform">
                  <div class="textatraBox" >
                    <el-input type="textarea" autosize placeholder="请输入内容" v-model="note"
                              style="width: 60%" :rows="2" resize="none">
                    </el-input>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="诊断管理" style="margin-bottom: 12px">
                <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                  <el-button type="success" @click="addNewDiagnosis">新增诊断</el-button>
                </div>
              </el-form-item>

              <!-- 诊断表格 -->
              <div>
                <el-table :data="prescriptionDiseInfoQOList" style="width: 100%; margin-bottom: 12px"
                          :height="getDiagnosisTableHeight">
                  <!-- 诊断类别列 -->
                  <el-table-column label="诊断类别">
                    <template slot-scope="scope">
                      <el-select disabled v-model="scope.row.diagType" style="width: 100%"
                                 @change="onDiagTypeChange(scope.row)">
                        <el-option label="西医诊断" value="1" :key="`diagType_${scope.$index}_1`"></el-option>
                        <el-option label="中医诊断" value="2" :key="`diagType_${scope.$index}_2`"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>

                  <!-- 主诊断标志列 -->
                  <el-table-column label="主诊断标志">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.mainDiagFlag" style="width: 100%">
                        <el-option label="是" value="1" :key="`mainDiag_${scope.$index}_1`"></el-option>
                        <el-option label="否" value="0" :key="`mainDiag_${scope.$index}_0`"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>

                  <!-- 诊断名称列 - 可编辑下拉框 -->
                  <el-table-column :label="isTraditionalChineseMedicine ? '中医病名' : '诊断名称'">
                    <template slot-scope="scope">
                      <InputLoadMore v-if="scope.row.diagType === '3'" v-model="scope.row.diagName"
                                     :get-option-fn="getTcmDiagnosisOptions" search-key="keyword"
                                     placeholder="请选择中医病名"
                                     @select="(item) => onDiagnosisAutocompleteSelect(item, scope.row, scope.$index)"
                                     @blur="onDiagnosisBlur(scope.row, scope.$index)" style="width: 100%"/>
                      <InputLoadMore v-else-if="scope.row.diagType === '1'" v-model="scope.row.diagName"
                                     :get-option-fn="getWesternDiagnosisOptions" search-key="keyword"
                                     placeholder="请选择西医诊断名称"
                                     @select="(item) => onDiagnosisAutocompleteSelect(item, scope.row, scope.$index)"
                                     @blur="onDiagnosisBlur(scope.row, scope.$index)" style="width: 100%"/>
                      <el-autocomplete v-else v-model="scope.row.diagName"
                                       :fetch-suggestions="(query, callback) => searchDiagnosisAutocomplete(query, callback, scope.$index)"
                                       placeholder="请选择诊断" style="width: 100%"
                                       @select="(item) => onDiagnosisAutocompleteSelect(item, scope.row, scope.$index)"
                                       @blur="onDiagnosisBlur(scope.row, scope.$index)">
                        <template slot-scope="{ item }">
                          <div class="name">{{ item.value }}</div>
                        </template>
                      </el-autocomplete>
                    </template>
                  </el-table-column>

                  <el-table-column v-if="isTraditionalChineseMedicine" label="中医证候">
                    <template slot-scope="scope">
                      <InputLoadMore v-model="scope.row.sympName" :get-option-fn="getTcmSyndromeOptions"
                                     search-key="keyword" placeholder="请选择中医证候"
                                     @select="(item) => onSyndromeAutocompleteSelect(item, scope.row, scope.$index)"
                                     @blur="onSyndromeBlur(scope.row, scope.$index)" style="width: 100%"/>
                    </template>
                  </el-table-column>

                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button type="danger" plain @click="deleteDiagnosisRow(scope.$index)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <el-form-item label="开具药品" style="margin-bottom: 12px">
                <div style="display: flex; align-items: center; gap: 15px;">
                  <el-button type="success" @click="getMedicineList()">开药</el-button>
                  <!-- 中药味数统计 -->
                  <span v-if="isTraditionalChineseMedicine" style="color: #67C23A; font-weight: 500; font-size: 14px;">
                    已添加 {{ formParams.tableData.length }} 味中药
                  </span>
                </div>
              </el-form-item>
              <!-- 西药表格显示 -->
              <el-form v-if="!isTraditionalChineseMedicine" :model="formParams" :rules="rules" ref="ruleForm">
                <el-table :data="formParams.tableData" stripe style="width: 100%; margin-bottom: 12px" height="286" :row-style="{ height: '44px' }" :cell-style="{ padding: '8px 0' }">
                  <el-table-column prop="drugCode" label="医保编码" :show-overflow-tooltip="true"
                                   class-name="offset-column">
                  </el-table-column>
                  <el-table-column prop="drugName" label="药品" :show-overflow-tooltip="true"
                                   class-name="offset-column">
                  </el-table-column>
                  <el-table-column prop="usageAndDosage" label="用法用量" :show-overflow-tooltip="true"
                                   class-name="offset-column">
                  </el-table-column>
                  <el-table-column prop="specification" label="规格" :show-overflow-tooltip="true"
                                   class-name="offset-column">
                  </el-table-column>
                  <el-table-column prop="specification" label="总量" :show-overflow-tooltip="true"  width="100px"
                                   class-name="offset-column">
                    <template slot-scope="scope">
                      <div class="total-quantity-content">
                        {{ scope.row.minPackageQuantity }}
                        {{ scope.row.minPreparationUnit }}
                      </div>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column prop="address" label="总量"> </el-table-column> -->
                  <el-table-column label="数量" width="100px">
                    <template slot-scope="scope">
                      <el-form-item :prop="'tableData.' + scope.$index + '.drugNumber'" :rules="rules2.drugNumber"
                                    class="tableFormItem">
                        <el-input v-model="scope.row.drugNumber" class="numberInput" @input="
                          scope.row.drugNumber = scope.row.drugNumber.replace(
                            /^(0+)|[^\d]/g,
                            ''
                          );
                        updateDays(scope.$index);
                        "></el-input>
                        <span>{{ scope.row.minPackageUnit }}</span>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="频次" width="140px">
                    <template slot-scope="scope">
                      <el-form-item :prop="'tableData.' + scope.$index + '.frquCode'" :rules="rules2.frquCode"
                                    class="tableFormItem">
                        <el-select v-model="scope.row.frquCode" placeholder="请选择频次"
                                   @change="frquNameChange(scope.$index, $event); updateDays(scope.$index);" filterable
                                   style="min-width: 120px; width: auto;">
                          <el-option v-for="item in frquOptions" :key="`frqu_${scope.$index}_${item.value}`"
                                     :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column prop="" label="单次用量" width="80px">
                    <template slot-scope="scope">
                      <el-form-item :prop="'tableData.' + scope.$index + '.sinDoscnt'" :rules="rules2.sinDoscnt"
                                    class="tableFormItem">
                        <el-input v-model="scope.row.sinDoscnt" @input="
                        (scope.row.sinDoscnt = scope.row.sinDoscnt
                          .replace(/[^\d.]/g, '')
                          .replace(/\.{2,}/g, '.')
                          .replace('.', '$#$')
                          .replace(/\./g, '')
                          .replace('$#$', '.')
                          .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
                          .replace(/^\./g, '')
                          .replace(/^0+(?!\.|$)/g, '')),
                          (scope.row.sinDoscnt =
                            Number(scope.row.sinDoscnt) >= 999999.99
                              ? 999999.99
                              : scope.row.sinDoscnt);
                        updateDays(scope.$index);
                        "></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column prop="" label="单次计量单位" width="120px">
                    <template slot-scope="scope">
                      <el-form-item :prop="'tableData.' + scope.$index + '.sinDosunt'" :rules="rules2.sinDosunt"
                                    class="tableFormItem">
                        <!-- <el-input v-model="scope.row.sinDosunt"></el-input> -->
                        <el-select v-model="scope.row.sinDosunt" placeholder="请选择" filterable>
                          <el-option v-for="item in filteredSinDosuntOptions(scope.row.minPreparationUnit)"
                                     :key="`sinDosunt_${scope.$index}_${item.value}`" :label="item.label"
                                     :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="用法" width="140px">
                    <template slot-scope="scope">
                      <el-form-item :prop="'tableData.' + scope.$index + '.wayCode'" :rules="rules2.wayCode"
                                    class="tableFormItem">
                        <el-select v-model="scope.row.wayCode" placeholder="请选择用法"
                                   @change="wayNameChange(scope.$index, $event)" filterable>
                          <el-option v-for="item in wayOptions" :key="`way_${scope.$index}_${item.value}`"
                                     :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="天数" width="80px">
                    <template slot-scope="scope">
                      <el-form-item :prop="'tableData.' + scope.$index + '.days'" :rules="rules2.days"
                                    class="tableFormItem">
                        <el-input v-model.lazy="scope.row.days" @input="
                          scope.row.days = scope.row.days.replace(
                            /^(0+)|[^\d]/g,
                            ''
                          )
                          "></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column prop="address" label="操作" width="100px">
                    <template slot-scope="scope">
                        <el-button type="danger" plain @click="delMedicinal(scope.row, scope.$index)">删除
                        </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form>

              <!-- 中药卡片显示 -->
              <div v-if="isTraditionalChineseMedicine" class="chinese-medicine-cards">
                <div v-if="formParams.tableData.length === 0" class="empty-state">
                  <img src="@/img/nullStatus.png" alt="暂无数据" class="empty-image">
                  <p style="color: #909399; margin-top: 10px;">暂无数据</p>
                </div>
                <div v-else class="medicine-cards-container">
                  <div v-for="(item, index) in formParams.tableData" :key="item.drugCode" class="medicine-card">
                    <div class="card-content">
                      <div class="medicine-info">
                        <div class="medicine-name">{{ item.drugName }}</div>
                        <div class="medicine-code">{{ item.drugCode }}</div>
                        <div class="medicine-price">
                          <span class="price-label">单价：</span>
                          <span class="price-value">￥{{ (item.drugPrice || 0).toFixed(2) }}</span>
                        </div>
                        <div class="medicine-total">
                          <span class="total-label">总价：</span>
                          <span class="total-value">￥{{ (item.totalPrice || 0).toFixed(2) }}</span>
                        </div>
                      </div>
                      <div class="medicine-quantity">
                        <span class="quantity-label">数量：</span>
                        <el-input v-model="item.drugNumber" placeholder="数量" size="mini" class="quantity-input"
                                  @input="updateDays(index)"></el-input>
                        <span class="quantity-unit">{{ item.minPackageUnit }}</span>
                      </div>
                      <div class="medicine-remark">
                        <span class="remark-label">备注：</span>
                        <el-select v-model="item.wayName" placeholder="请选择" size="mini" class="remark-select" filterable>
                          <el-option v-for="opt in drugRemarkOptions" :key="opt.value" :label="opt.label" :value="opt.value">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="card-actions">
                      <el-button type="text" icon="el-icon-close" class="delete-btn" @click="delMedicinal(item, index)"
                                 title="删除"></el-button>
                    </div>
                  </div>
                </div>
              </div>
            </el-form>

            <div v-loading="extractionLoading" style="width: 180px; height: 48px; margin: 10px auto">
              <el-button type="success" size="small" @click="extraction()" class="upButton">开方
              </el-button>
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog title="开具诊断" :visible.sync="prescriptionDiseInfoQO" width="50%" center
                 :close-on-click-modal="false">
        <div style="margin-bottom: 10px">
          <span style="line-height: 40px">{{ diagnosisNameLabel }}：</span>
          <el-input :placeholder="diagnosisSearchPlaceholder" v-model="condition" @change="searchList()">
          </el-input>
        </div>
        <table style="width: 100%">
          <tr>
            <td>
              <span style="line-height: 40px"><span style="color: red">*</span>主诊断标志：</span>
              <el-select v-model="mainDiagFlag" placeholder="请选择主诊断标志" @change="changeData()">
                <el-option v-for="item in mainDiagFlagList" :key="`mainDiagFlag_${item.value}`" :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </td>
            <td>
              <span style="line-height: 40px"><span style="color: red">*</span>诊断类别：</span>
              <el-select v-model="diagType" placeholder="请选择诊断类别" @change="changeData()">
                <el-option v-for="item in diagTypeList" :key="`diagType_${item.value}`" :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td>
              <span style="color: red; margin-left: 90px" v-if="NullFlag == false">请选择主诊断标志</span>
            </td>
            <td>
              <span style="color: red; margin-left: 78px" v-if="NullFlag2 == false">请选择诊断类别</span>
            </td>
          </tr>
        </table>
        <template>
          <el-table style="width: 100%; height: 455px" :data="dictDataListData" v-loading="loading1">
            <el-table-column prop="diagnosisName" :label="diagnosisNameLabel" width="180">
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <el-button type="success" size="mini" class="addButton" @click="AddDictData(scope.row)">添加
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <el-pagination @current-change="handleCurrentChange2" :page-size="8" layout="total, prev, pager, next"
                       :total="PageCounts2" class="paginationBox" align="center">
        </el-pagination>
      </el-dialog>
      <el-dialog title="开药" :visible.sync="medicineDialog" width="70%" center :close-on-click-modal="false">
        <div style="display: flex; align-items: center; gap: 15px; margin-bottom: 10px;">
          <span style="line-height: 40px; white-space: nowrap;"> 搜索药品 </span>
          <el-select disabled v-model="drugTypeFilter" placeholder="请选择药品类型" style="width: 120px;"
                     @change="searchMedicineList">
            <el-option v-for="item in drugTypeFilterOptions" :key="`drugTypeFilter_${item.value}`" :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="search" placeholder="可搜索药品名称/批准文号/医保编码/条形码 空格 生产厂家 按回车搜索"
                    @keydown.native.enter="searchMedicineList"/>
        </div>
        <div v-loading="loading2">
          <el-table :data="prescriptionData" :row-class-name="tableRowClassName" @row-click="handleRowClick"
                    @selection-change="handleSelectionChange" :row-style="rowClass" :highlight-current-row="false"
                    :row-key="getRowKey" ref="medicineTable" style="height: 551px; width: 100%;"
                    :cell-style="{ padding: '8px 0' }">
            <!-- 中药多选列 -->
            <el-table-column v-if="rxTypeCode === '2'" type="selection" :reserve-selection="true" align="center">
            </el-table-column>
            <el-table-column label="药品类型" width="80px">
              <template slot-scope="scope">
                <span v-if="scope.row.drugType == 1" class="statusStyle4">西药</span>
                <span v-else-if="scope.row.drugType == 2" class="statusStyle2">中药</span>
                <span v-else style="color: #909399;">未知</span>
              </template>
            </el-table-column>
            <!-- 中药数量列 -->
            <el-table-column prop="drugName" label="药品名" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="drugCode" label="医保编码" :show-overflow-tooltip="true"
                             width="140px"></el-table-column>
            <el-table-column v-if="rxTypeCode === '2'" label="数量" align="left" width="120px">
              <template slot-scope="scope">
                <div style="display: flex; align-items: center; height: 100%;">
                  <el-input-number v-model="scope.row.selectedQuantity" :min="1" :max="999" :step="1" size="small"
                                   placeholder="数量" class="quantity-input-number"
                                   @change="updateSelectedQuantity(scope.row)"
                                   @focus="handleQuantitySelectFocus(scope.row)">
                  </el-input-number>
                  <span style="margin-left: 10px; font-size: 14px; color: #606266;">{{ scope.row.minPackageUnit }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-if="rxTypeCode === '2'" label="备注" align="left" width="180px">
              <template slot-scope="scope">
                <div style="display: flex; align-items: center; height: 100%;margin-top: 8px;">
                  <el-select v-model="scope.row.remarkWayName" placeholder="请选择" size="small" 
                             @change="updateRemarkWayName(scope.row)" filterable style="width: 120px;">
                    <el-option v-for="opt in drugRemarkOptions" :key="opt.value" :label="opt.label" :value="opt.value">
                    </el-option>
                  </el-select>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="commodityName" label="商品名" :show-overflow-tooltip="true"
                             v-if="drugTypeFilter != 2"></el-table-column>
            <el-table-column prop="specification" label="规格" :show-overflow-tooltip="true"
                             v-if="drugTypeFilter != 2"></el-table-column>
            <el-table-column prop="specification" label="总量" :show-overflow-tooltip="true" width="100px"
                             v-if="drugTypeFilter != 2">
              <template slot-scope="scope">
                <div>
                  {{
                    scope.row.minPackageQuantity
                  }}{{ scope.row.minPreparationUnit }}/{{
                    scope.row.minPackageUnit
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="productorName" label="生产企业" width="120px" :show-overflow-tooltip="true"
                             v-if="drugTypeFilter != 2"></el-table-column>
            <el-table-column prop="approvalNumber" label="批准文号" width="120px" :show-overflow-tooltip="true"
                             v-if="drugTypeFilter != 2"></el-table-column>
            <el-table-column prop="validMark" label="是否有效" width="80px" v-if="drugTypeFilter != 2">
              <template slot-scope="scope">
                <div v-if="scope.row.validMark == 1">
                  <span class="statusIcon" style="background: #0caf60">&nbsp;</span><span>有效</span>
                </div>
                <div v-else>
                  <span class="statusIcon" style="background: red">&nbsp;</span><span>无效</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 中药批量添加按钮 -->
        <div v-if="rxTypeCode === '2'" style="text-align: center; margin: 15px 0;">
          <el-button type="success" @click="batchAddChineseMedicines" :disabled="selectedChineseMedicines.length === 0"
                     size="medium">
            我要开以上药材 ({{ selectedChineseMedicines.length }})
          </el-button>
        </div>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page.sync="currentPage1" :page-size="8" layout="total, prev, pager, next"
                       :total="PageCounts"
                       class="paginationBox" align="center">
        </el-pagination>
      </el-dialog>
      <el-dialog :visible.sync="tipsFlag2" width="30%" :show-close="false" :close-on-click-modal="false"
                 class="tipsMsgBox" :modal="false">
        <span style="font-size: 20px; font-weight: 800">{{ tipsMsg }}</span>
      </el-dialog>
      <el-dialog :visible.sync="tipsFlag" width="30%">
        <span>请尽快结束该问诊</span>
      </el-dialog>
    </el-container>
  </div>
</template>

<script>
import store from "../../../store/store";
import myAside from "./components/myAside.vue";
import myMain from "./components/myMain.vue";
import myFooter from "./components/myFooter.vue";
import InputLoadMore from "./components/InputLoadMore.vue";
import request from '@/config/axios'
import {
  dictDataList,
  Extraction,
  imgDownLoad,
  Medicinal_Search,
  overOrder,
  queryInHospInfo,
  queryPsnOpspReg,
  refuse,
  sicknessList,
  Treated
} from "../../../api/index";
import {getsocketUrl} from "@/utils/index";

export default {
  name: "App",
  components: {myAside, myMain, myFooter, InputLoadMore},

  data() {
    return {
      count: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      username: "",
      choosed: "",
      prescriptionData: [],
      zdName: "",
      note: "",

      RxType: [
        {
          value: "1",
          label: "门诊西药",
        },
        {
          value: "2",
          label: "门诊中药饮片",
        },
      ],
      mainDiagFlagList: [
        {
          value: "0",
          label: "否",
        },
        {
          value: "1",
          label: "是",
        },
      ],
      diagTypeList: [
        {
          value: "1",
          label: "西医诊断",
        },
        {
          value: "2",
          label: "中医诊断",
        },
        {
          value: "3",
          label: "中医证候",
        },
      ],
      value: "",
      date: "",
      searchInput: "",
      medicineDialog: false,
      MedicineQuery: {
        id: "",
      },
      // 中药多选相关
      selectedChineseMedicines: [], // 选中的中药列表
      selectedMedicineIds: new Set(), // 选中的药品ID集合，用于快速查找
      selectRow: [], // 选中行的索引数组，用于高亮显示
      quantityStorage: new Map(), // 保存每个药品的数量状态，key为drugCode，value为selectedQuantity
      remarkStorage: new Map(), // 保存每个药品的备注状态，key为drugCode，value为remarkWayName
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      rules: {
        mainDiagFlag: [
          {required: true, message: "请选择主诊断标志", trigger: "change"},
        ],
        diagType: [
          {required: true, message: "请选择诊断类别", trigger: "change"},
        ],
      },
      surrferId: "",
      search: "",
      PageCounts: 10,
      PageCounts2: 0,
      total: 10,
      currentPage1: 1,
      reLoadAsideFlag: 0,
      recordFlag: "",
      prescriptionDiseInfoQO: false,

      condition: "",
      dictDataListData: [],
      prescriptionDiseInfoQOList: [],
      mainDiagFlag: "1",
      NullFlag: true,
      NullFlag2: true,
      diagType: "1",
      rxTypeCode: "1",

      // 中药诊断相关数据
      tcmDiagnosisInput: "",
      tcmSyndromeInput: "",
      selectedTcmDiagnosis: null,
      tcmDiagnosisList: [],
      tcmDiagType: "2", // 中医诊断类别：2-中医诊断，3-中医证候
      tcmMainDiagFlag: "1", // 主诊断标志：1-是，0-否
      num: 2,
      wayName: "水煎内服",
      frquName: "每日1剂",
      frquNum: 1,
      frquPreNum: 2,
      sinDoscnt: 100,
      sinDosunt: "ml",
      usageTime: "饭后半小时",
      chineseMedicineSinglePrice: 0,
      chineseMedicineTotalPrice: 0,
      drugType: 1,
      decoctingMethod: 1, // 煎药方式：1-自煎，2-代煎
      decoctingMethodOptions: [
        {value: 1, label: "自煎"},
        {value: 2, label: "代煎"},
        {value: 3, label: "膏方"},
        {value: 4, label: "磨粉"}
      ],
      frquOptions: [{
        value: "11",
        label: "每天一次（qd）",
      },
        {
          value: "12",
          label: "每天二次（bid）",
        },
        {
          value: "13",
          label: "每天三次（tid）",
        },
        {
          value: "14",
          label: "每天四次（qid）",
        },
        {
          value: "5次/天",
          label: "5次/天",
        },
        {
          value: "21",
          label: "每周一次（qw）",
        },
        {
          value: "22",
          label: "每周二次（biw）",
        },
        {
          value: "23",
          label: "每周三次（tiw）",
        },
        {
          value: "1次/2周",
          label: "1次/2周",
        },
        {
          value: "1次/3周",
          label: "1次/3周",
        },
        {
          value: "1次/2天",
          label: "1次/2天",
        },
        {
          value: "1次/3天",
          label: "1次/3天",
        },
        {
          value: "1次/4天",
          label: "1次/4天",
        },
        {
          value: "31",
          label: "每小时一次（qh）",
        },
        {
          value: "32",
          label: "每2小时一次（q2h）",
        },
        {
          value: "1次/3小时",
          label: "1次/3小时",
        },
        {
          value: "33",
          label: "每4小时一次（q4h）",
        },
        {
          value: "34",
          label: "每5小时一次（q5h）",
        },
        {
          value: "35",
          label: "每6小时一次（q6h）",
        },
        {
          value: "36",
          label: "每8小时一次（q8h）",
        },
        {
          value: "37",
          label: "每12小时一次（q12h）",
        },
        {
          value: "41",
          label: "每晚一次（qn）",
        },
        {
          value: "42",
          label: "隔天一次（qod）",
        },
        {
          value: "43",
          label: "五天一次（q5d）",
        },
        {
          value: "44",
          label: "十天一次（q10d）",
        },
        {
          value: "51",
          label: "12小时维持",
        },
        {
          value: "52",
          label: "24小时维持",
        },
        {
          value: "61",
          label: "立即（st）",
        },
        {
          value: "62",
          label: "必要时使用（prn）",
        },
      ],
      wayNameOptions: [
        {value: '烊化兑服', label: '烊化兑服'},
        {value: '水煎内服', label: '水煎内服'},
        {value: '泡水服', label: '泡水服'},
        {value: '外搽', label: '外搽'},
        {value: '泡药浴', label: '泡药浴'}
      ],
      // 药品备注
      drugRemarkOptions: [
        {value: '先煎', label: '先煎'},
        {value: '后下', label: '后下'},
        {value: '水煎服', label: '水煎服'},
        {value: '冲服', label: '冲服'},
        {value: '包煎', label: '包煎'},
        {value: '另煎', label: '另煎'},
        {value: '烊化', label: '烊化'},
        {value: '磨粉', label: '磨粉'},
        {value: '另包', label: '另包'}
      ],
      frquNameOptions: [
        {value: "每日1剂 每日1次", label: "每日1剂 每日1次"},
        {value: "每日1剂 每日2次", label: "每日1剂 每日2次"},
        {value: "每日1剂 每日3次", label: "每日1剂 每日3次"},
        {value: "每日1剂 每日4次", label: "每日1剂 每日4次"},
      ],
      frquNumOptions: [
        {value: 1, label: "1剂"},
        {value: 1, label: "1剂"},
        {value: 1, label: "1剂"},
        {value: 1, label: "1剂"}
      ],
      frquPreNumOptions: [
        {value: 1, label: "1次"},
        {value: 2, label: "2次"},
        {value: 3, label: "3次"},
        {value: 4, label: "4次"}
      ],
      // TCM专用计量单位选项
      tcmSinDosuntOptions: [
        {value: 'ml', label: 'ml'},

      ],
      usageTimeOptions: [
        {value: '饭后半小时', label: '饭后半小时'},
        {value: '饭前半小时', label: '饭前半小时'},
        {value: '空腹用药', label: '空腹用药'},
        {value: '睡前用药', label: '睡前用药'},
        {value: '晨起用药', label: '晨起用药'}
      ],
      chineseMedicineDosesOptions: [
        {value: 5, label: "5"},
        {value: 7, label: "7"},
        {value: 10, label: "10"},
        {value: 14, label: "14"},
        {value: 21, label: "21"}
      ],
      drugTypeOptions: [
        {value: 0, label: "颗粒"},
        {value: 1, label: "饮片"}
      ],
      drugTypeFilter: "", // 药品类型筛选
      drugTypeFilterOptions: [
        {value: 1, label: "西药"},
        {value: 2, label: "中药"}
      ],
      wayOptions: [{
        value: "1",
        label: "口服",
      },
        {
          value: "泡水冲服",
          label: "泡水冲服",
        },
        {
          value: "咀嚼服用",
          label: "咀嚼服用",
        },
        {
          value: "含服",
          label: "含服",
        },
        {
          value: "烊化兑服",
          label: "烊化兑服",
        },
        {
          value: "舌下含服",
          label: "舌下含服",
        },
        {
          value: "含漱",
          label: "含漱",
        },
        {
          value: "煎服",
          label: "煎服",
        },
        {
          value: "外用",
          label: "外用",
        },
        {
          value: "2",
          label: "直肠给药",
        },
        {
          value: "灌肠",
          label: "灌肠",
        },
        {
          value: "3",
          label: "舌下给药",
        },
        {
          value: "4",
          label: "注射给药",
        },
        {
          value: "401",
          label: "皮下注射",
        },
        {
          value: "402",
          label: "皮内注射",
        },
        {
          value: "403",
          label: "肌肉注射",
        },
        {
          value: "404",
          label: "静脉注射",
        },
        {
          value: "5",
          label: "吸入给药",
        },
        {
          value: "雾化吸入",
          label: "雾化吸入",
        },
        {
          value: "经口吸入",
          label: "经口吸入",
        },
        {
          value: "鼻腔吸入",
          label: "鼻腔吸入",
        },
        {
          value: "6",
          label: "局部用药",
        },
        {
          value: "601",
          label: "椎管内用药",
        },
        {
          value: "602",
          label: "关节腔内用药",
        },
        {
          value: "603",
          label: "胸膜腔用药",
        },
        {
          value: "604",
          label: "腹腔用药",
        },
        {
          value: "605",
          label: "阴道用药",
        },
        {
          value: "606",
          label: "气管内用药",
        },
        {
          value: "607",
          label: "滴眼",
        },
        {
          value: "608",
          label: "滴鼻",
        },
        {
          value: "609",
          label: "喷喉",
        },
        {
          value: "610",
          label: "含化",
        },
        {
          value: "611",
          label: "敷伤口",
        },
        {
          value: "612",
          label: "擦皮肤",
        },
        {
          value: "喷鼻",
          label: "喷鼻",
        },
        {
          value: "滴耳",
          label: "滴耳",
        },
        {
          value: "涂眼",
          label: "涂眼",
        },
        {
          value: "喷患处",
          label: "喷患处",
        },
        {
          value: "贴敷",
          label: "贴敷",
        },
        {
          value: "外用清洗",
          label: "外用清洗",
        },
        {
          value: "699",
          label: "其他局部给药途径",
        },
        {
          value: "9",
          label: "其他给药途径",
        },
      ],
      loading1: false,
      loading2: false,
      tipsFlag: false,
      CF_Flag: false,
      loading3: false,
      loading4: false,
      flagTrue: false,
      socketUrl2: getsocketUrl(),
      tipsFlag2: false,
      tipsMsg: "",
      AddMedicinalFlag: true,
      scrollFlag: "",
      resetFlag: "",
      pre_FLag: false,
      showMsgFlag: "",
      formParams: {
        tableData: [],
      },
      rules2: {
        drugNumber: [{required: true, trigger: "blur"}],
        frquCode: [{required: true, trigger: "change"}],
        sinDoscnt: [{required: true, trigger: "blur"}],
        sinDosunt: [{required: true, trigger: "change"}],
        wayCode: [{required: true, trigger: "change"}],
        days: [{required: true, trigger: "blur"}],
      },
      submitFlag: false,
      sinDosuntOptions: [{
        label: "片",
        value: "片",
      },
        {
          label: "粒",
          value: "粒",
        },
        {
          label: "支",
          value: "支",
        },
        {
          label: "瓶",
          value: "瓶",
        },
        {
          label: "袋",
          value: "袋",
        },
        {
          label: "丸",
          value: "丸",
        },
        {
          label: "枚",
          value: "枚",
        },
        {
          label: "贴",
          value: "贴",
        },
        {
          label: "锭",
          value: "碇",
        },
        {
          label: "块",
          value: "块",
        },
        {
          label: "包",
          value: "包",
        },
        {
          label: "个",
          value: "个",
        },
        {
          label: "喷",
          value: "喷",
        },
        {
          label: "揿",
          value: "揿",
        },
        {
          label: "吸",
          value: "吸",
        },
        {
          label: "滴",
          value: "滴",
        },
        {
          label: "汤匙",
          value: "汤匙",
        },
        {
          label: "盒",
          value: "盒",
        },
        {
          label: "听",
          value: "听",
        },
        {
          label: "套",
          value: "套",
        },
        {
          label: "g",
          value: "g",
        },
        {
          label: "mg",
          value: "mg",
        },
        {
          label: "ug",
          value: "ug",
        },
        {
          label: "ml",
          value: "ml",
        },
        {
          label: "U",
          value: "U",
        },
        {
          label: "IU",
          value: "IU",
        },
      ],
      PharmacyCp: 1,
      PharmacyKeyWord: "",
      socket_init: null,
      heartCheckStart: null,
      count: 0,
      count2: 0,
      heartCheck: null,
      lockReconnect: true,
      reconnectFlag: false,
      initFLag: false,
      extractionLoading: false,
      medicalCp: 1,
      mainDiagCount: 0,
      addFlag: true,
      inHospFlag: false,
      diseFlag: {
        display: 'none'
      },
      recommendDiseOptions: [],
      diseOptions: [],
      diseName: '',
      opspEchoInfo: null,
      mdtrtCertType: "",
      mdtrtCertNo: "",
      refundVisible: false,
      refundForm: {
        id: "",
        reasonCode: "",
        desc: "",
      },
      buttonLoading: false,
      rules: {
        reasonCode: [
          {required: true, message: "请选择退款原因", trigger: "change"},
        ],
      },
      // 拖拽相关数据
      isFooterDragging: false,
      footerStartY: 0,
      footerStartHeight: 0,
      footerMinHeight: 80,
      footerMaxHeight: 800,
      footerActiveZoneHeight: 8,
      footerActiveLeftSafe: 180,
      footerActiveRightSafe: 480,
    };
  },
  watch: {
    // 监听侧边栏选择导致的recordData变化，回显表单
    '$store.state.recordData': {
      deep: false,
      handler() {
        this.setFormFromRecordData();
      }
    },
    // 监听选中药品变化，更新高亮行索引
    selectedChineseMedicines(data) {
      this.selectRow = [];
      if (data.length > 0) {
        data.forEach((item) => {
          const index = this.prescriptionData.findIndex(row => row.drugCode === item.drugCode);
          if (index !== -1) {
            this.selectRow.push(index);
          }
        });
      }
    },
    userInfo() {
      // this.loadOrderDrugList();
      if (this.userInfo && this.userInfo.name) {
        this.recordFlag = this.userInfo.name;
        if (this.resetFlag == this.userInfo.name) {
          this.prescriptionDiseInfoQOList = [];
        }
        this.resetFlag = this.userInfo.name;
      }
      this.opspEchoInfo = null;
    },
    diseName() {
      if (this.diseName && this.diseName !== '') {
        this.opspEchoInfo = null;
      }
    },
    cf_flag() {
      let flag = false;
      if (
          store.state.CF_Flag &&
          store.state.showMsgFlag &&
          store.state.StatusFlag
      ) {
        flag = true;
      } else {
        flag = false;
      }
      this.pre_FLag = flag;
    },
    pre_FLag(val) {
      if (val) {
        this.formParams.tableData = JSON.parse(
            JSON.stringify(store.state.orderDrugList)
        );
      }
      if (this.pre_FLag == false) {
        store.commit("SET_CF_FLAG", this.pre_FLag);
      }
      if (this.pre_FLag == true) {
        this.note = "";
        this.search = "";
        this.condition = "";
        this.prescriptionDiseInfoQOList = [];
        
        const opspInfo = store.state.opspInfo;
        if (opspInfo && opspInfo.diseCode && opspInfo.diseName && opspInfo.medType) {
          let expContent = opspInfo.medType == "140104" ? 11 : (opspInfo.medType == "140201" ? 12 : null);
          if (expContent) {
            this.opspEchoInfo = {
              diseCode: opspInfo.diseCode,
              diseName: opspInfo.diseName,
              expContent: expContent
            };
          }
        }

        // 根据缓存中的prescrKind设置界面上的处方类别选择
        const prescrKind = localStorage.getItem('prescrKind');
        if (prescrKind === '1') {
          this.rxTypeCode = '1'; // 门诊西药
        } else if (prescrKind === '2') {
          this.rxTypeCode = '2'; // 门诊中药饮片
        }

        let recordData = store.state.recordData;
        let postData = {
          diagnosisNames: recordData.illName,
          type: localStorage.getItem('prescrKind') === '2' ? "3" : "1"
        };
        sicknessList(postData).then((data) => {
          if (data.code === 0) {
            const illNames = recordData.illName ? recordData.illName.split(/[\s,，]+/) : [];
            const illDescs = recordData.illDesc ? this.parseSyndromeNames(recordData.illDesc) : [];
            data.data.forEach((item) => {
              // 为当前诊断记录找到对应的证候
              let sympName = '';

              // 1. 优先进行精确匹配
              const exactMatchIndex = illNames.indexOf(item.diagnosisName);
              if (exactMatchIndex !== -1 && illDescs[exactMatchIndex]) {
                sympName = illDescs[exactMatchIndex];
              } else {
                // 2. 进行包含匹配
                for (let i = 0; i < illNames.length; i++) {
                  if (item.diagnosisName.includes(illNames[i]) &&
                      !illNames.some(name => name !== illNames[i] && name.includes(illNames[i]) && item.diagnosisName.includes(name))
                  ) {
                    if (illDescs[i]) {
                      sympName = illDescs[i];
                      break;
                    }
                  }
                }

                // 3. 如果还没有找到，尝试按顺序匹配
                if (!sympName) {
                  const diagnosisIndex = data.data.findIndex(d => d.diagnosisName === item.diagnosisName);
                  if (diagnosisIndex !== -1 && illDescs[diagnosisIndex]) {
                    sympName = illDescs[diagnosisIndex];
                  } else if (illDescs.length > 0) {
                    // 4. 如果证候数量多于病名，尝试智能分配
                    // 对于第一个病名，分配第一个证候
                    // 对于后续病名，分配剩余的证候
                    if (illNames.length === 1 && illDescs.length > 1) {
                      // 只有一个病名但有多个证候，全部分配给这个病名
                      sympName = illDescs.join(',');
                    } else if (illNames.length > 1 && illDescs.length > illNames.length) {
                      // 多个病名，证候数量更多，按顺序分配
                      const startIndex = Math.min(diagnosisIndex, illDescs.length - 1);
                      const endIndex = Math.min(startIndex + Math.ceil(illDescs.length / illNames.length), illDescs.length);
                      sympName = illDescs.slice(startIndex, endIndex).join(',');
                    } else if (illDescs.length > 0) {
                      // 默认分配第一个证候
                      sympName = illDescs[0];
                    }
                  }
                }
              }
              let data = {
                diagCode: item.diagnosisCode,
                diagName: item.diagnosisName,
                diagSrtNo: "",
                diagType: localStorage.getItem('prescrKind') === '2' ? "2" : "1",
                mainDiagFlag: "1",
                sympName: sympName,
                sympCode: "" // 初始为空，
              };
              this.prescriptionDiseInfoQOList.push(data);

              // 如果有证候名称，自动搜索并设置证候编码
              if (sympName && localStorage.getItem('prescrKind') === '2') {
                this.searchAndSetSyndromeCode(sympName, data);
              }
            })
          } else {
            this.errorTipsMsg(data.msg);
          }
        });
        if (this.$refs.ruleForm !== undefined) {
          // this.$refs.ruleForm.clearValidate();
          this.resetForm("ruleForm");
        }
        this.formParams.tableData = JSON.parse(
            JSON.stringify(store.state.orderDrugList)
        );
      }
    },
    medicineDialog(val) {
      if (!val) {
        this.search = "";
        this.prescriptionData = [];
        this.PageCounts = 0; // 重置分页总数
        this.medicalCp = 1; // 重置当前页码
        // 清空中药选中状态
        this.selectedChineseMedicines = [];
        this.selectedMedicineIds.clear();
        this.selectRow = []; // 清空高亮行索引
        // 清空表格选中状态
        if (this.$refs.medicineTable) {
          this.$refs.medicineTable.clearSelection();
        }
      }
    },
  },
  activated() {
    // 页面被激活时（从其他页面切换回来），恢复聊天状态
    console.log('聊天页面被激活，检查聊天状态');
    this.restoreChatStateOnActivation();
  },
  deactivated() {
    // 页面被停用时，清理定时器
    if (this.chatStateChecker) {
      clearInterval(this.chatStateChecker);
      this.chatStateChecker = null;
    }
  },
  beforeDestroy() {
    // 组件销毁时清理定时器
    if (this.chatStateChecker) {
      clearInterval(this.chatStateChecker);
      this.chatStateChecker = null;
    }

  },
  created() {
    var that = this;

    that.socketInit();
  },
  mounted() {
    var that = this;
    this.MedicineQuery.id = this.$store.state.doctorEmployeeNote;
    const prescrKind = localStorage.getItem('prescrKind');
    if (prescrKind) {
      if (prescrKind === 1 || null == prescrKind) {
        this.rxTypeCode = '1'; // 门诊西药
      } else if (prescrKind === '2') {
        this.rxTypeCode = '2'; // 门诊中药饮片
        // 初始为中药饮片时，默认单次计量单位为 ml
        this.sinDosunt = 'ml';
      }
    }

    // 根据侧边列表选中的订单，回显中药用法用量等参数
    this.setFormFromRecordData();

    // 恢复保存的footer高度
    this.$nextTick(() => {
      this.restoreFooterHeight();
      this.bindFooterDragEvents();
    });
    // 启动定时检查，确保聊天状态正确
    this.startChatStateChecker();


  },
  methods: {
    // 从store中的recordData回显中药用法用量配置
    setFormFromRecordData() {
      const data = this.$store && this.$store.state && this.$store.state.recordData ? this.$store.state.recordData : null;
      if (!data) return;
      // 仅在中药处方类别时回显
      if (String(data.prescrKind) === '2') {
        if (data.num !== undefined && data.num !== null) this.num = data.num;
        if (data.wayName) this.wayName = data.wayName;
        if (data.frquName) this.frquName = data.frquName;
        if (data.frquNum !== undefined && data.frquNum !== null) this.frquNum = data.frquNum;
        if (data.frquPreNum !== undefined && data.frquPreNum !== null) this.frquPreNum = data.frquPreNum;
        if (data.sinDoscnt !== undefined && data.sinDoscnt !== null) this.sinDoscnt = data.sinDoscnt;
        if (data.sinDosunt) this.sinDosunt = data.sinDosunt;
        if (data.usageTime) this.usageTime = data.usageTime;
        if (data.drugType !== undefined && data.drugType !== null) this.drugType = data.drugType;
        if (data.decoctingMethod !== undefined && data.decoctingMethod !== null) this.decoctingMethod = data.decoctingMethod;

        // 计算单副金额和总计金额
        if (data.orderDrugList && Array.isArray(data.orderDrugList)) {
          // 单副金额 = 每个药材的totalPrice累加（已包含数量的总价）
          const singleDosePrice = data.orderDrugList.reduce((sum, drug) => {
            return sum + (parseFloat(drug.totalPrice) || 0);
          }, 0);
          this.chineseMedicineSinglePrice = Math.round(singleDosePrice * 100) / 100;

          // 总计金额 = 单副金额 × 用药数量
          this.chineseMedicineTotalPrice = Math.round((this.chineseMedicineSinglePrice * (parseFloat(this.num) || 0)) * 100) / 100;
        }
      }
    },
    // 处方类别变化处理
    onRxTypeChange(newValue) {
      console.log('处方类别变化:', newValue);
      // 根据处方类别自动设置诊断类别
      if (newValue === '1') {
        // 门诊西药处方 -> 西医诊断
        this.diagType = '1';
        // 更新已存在的诊断记录的诊断类别
        this.prescriptionDiseInfoQOList.forEach(item => {
          item.diagType = '1';
        });
      } else if (newValue === '2') {
        // 门诊中药饮片 -> 中医诊断
        this.diagType = '2';
        // 更新已存在的诊断记录的诊断类别
        this.prescriptionDiseInfoQOList.forEach(item => {
          item.diagType = '2';
        });
      }

      // 根据处方类别设置药品类型筛选参数和默认值
      if (newValue === '2') {
        // 门诊中药饮片 - 设置中药筛选参数
        this.drugTypeFilter = 2;
        // 中药饮片默认单次计量单位为 ml
        this.sinDosunt = 'ml';
        // 中药饮片默认用药方式与时间
        this.wayName = '水煎内服';
        this.usageTime = '饭后半小时';
      } else {
        // 门诊西药 - 设置西药筛选参数
        this.drugTypeFilter = 1;
      }

    },
    // 计算中药饮片单副金额
    calculateChineseMedicineSinglePrice() {
      if (this.formParams.tableData && this.formParams.tableData.length > 0) {
        // 单副金额 = 每个药品的totalPrice总和（后端已计算好）
        const singlePrice = this.formParams.tableData.reduce((sum, drug) => {
          return sum + (parseFloat(drug.totalPrice) || 0);
        }, 0);
        this.chineseMedicineSinglePrice = Math.round(singlePrice * 100) / 100;
      } else {
        this.chineseMedicineSinglePrice = 0;
      }
    },
    // 计算中药饮片总计金额
    calculateTotalPrice() {
      const doses = parseFloat(this.num) || 0;
      const singlePrice = parseFloat(this.chineseMedicineSinglePrice) || 0;
      if (doses > 0 && singlePrice > 0) {
        this.chineseMedicineTotalPrice = Math.round((doses * singlePrice) * 100) / 100;
      } else {
        this.chineseMedicineTotalPrice = 0;
      }
    },

    // 搜索中医诊断
    async searchTcmDiagnosis(queryString, cb) {
      if (!queryString) {
        cb([]);
        return;
      }
      try {
        const postData = {
          cp: "1",
          lz: 8,
          dictType: "diag_type",
          keyword: queryString,
          type: '2' // 中医诊断
        };
        const response = await dictDataList(postData);
        if (response.data && response.data.data) {
          const formattedData = response.data.data.map(item => ({
            dictLabel: item.diagnosisName,
            dictValue: item.diagnosisCode,
            type: item.type
          }));
          cb(formattedData);
        } else {
          cb([]);
        }
      } catch (error) {
        console.error('搜索中医诊断失败:', error);
        cb([]);
      }
    },

    // 搜索中医证候
    async searchTcmSyndrome(queryString, cb) {
      if (!queryString) {
        cb([]);
        return;
      }
      try {
        const postData = {
          cp: "1",
          lz: 8,
          dictType: "diag_type",
          keyword: queryString,
          type: '4' // 中医证候
        };
        const response = await dictDataList(postData);
        if (response.data && response.data.data) {
          const formattedData = response.data.data.map(item => ({
            dictLabel: item.diagnosisName,
            dictValue: item.diagnosisCode,
            type: item.type
          }));
          cb(formattedData);
        } else {
          cb([]);
        }
      } catch (error) {
        console.error('搜索中医证候失败:', error);
        cb([]);
      }
    },

    // 为 InputLoadMore 组件提供的中医诊断搜索方法
    async getTcmDiagnosisOptions(params) {
      const postData = {
        cp: params.page.toString(),
        lz: params.pageSize.toString(),
        dictType: "diag_type",
        keyword: params.keyword,
        type: '2' // 中医诊断
      };
      return await dictDataList(postData);
    },

    // 为 InputLoadMore 组件提供的西医诊断搜索方法
    async getWesternDiagnosisOptions(params) {
      const postData = {
        cp: params.page.toString(),
        lz: params.pageSize.toString(),
        dictType: "diag_type",
        keyword: params.keyword,
        type: '1' // 西医诊断
      };
      return await dictDataList(postData);
    },

    // 为 InputLoadMore 组件提供的中医证候搜索方法
    async getTcmSyndromeOptions(params) {
      const postData = {
        cp: params.page.toString(),
        lz: params.pageSize.toString(),
        dictType: "diag_type",
        keyword: params.keyword,
        type: '3' // 中医证候
      };
      return await dictDataList(postData);
    },

    // 选择中医诊断
    selectTcmDiagnosis(item) {
      this.selectedTcmDiagnosis = item;
      this.tcmDiagnosisInput = item.dictLabel;
      // 清空证候输入
      this.tcmSyndromeInput = "";
    },

    // 选择中医证候
    selectTcmSyndrome(item) {
      if (!this.selectedTcmDiagnosis) {
        this.$message.warning('请先选择中医病名');
        return;
      }

      // 添加到列表
      this.tcmDiagnosisList.push({
        diagnosisName: this.selectedTcmDiagnosis.dictLabel,
        diagnosisCode: this.selectedTcmDiagnosis.dictValue,
        syndromeName: item.dictLabel,
        syndromeCode: item.dictValue,
        diagType: this.tcmDiagType, // 使用用户选择的诊断类别
        mainDiagFlag: this.tcmMainDiagFlag // 使用用户选择的主诊断标志
      });

      // 清空输入
      this.tcmDiagnosisInput = "";
      this.tcmSyndromeInput = "";
      this.selectedTcmDiagnosis = null;

      this.$message.success('已添加中医诊断和证候');
    },

    // 移除中医诊断
    removeTcmDiagnosis(index) {
      this.tcmDiagnosisList.splice(index, 1);
    },
    // 启动聊天状态定时检查器
    startChatStateChecker() {
      // 每5秒检查一次聊天状态，确保状态同步
      this.chatStateChecker = setInterval(() => {
        this.checkAndSyncChatState();
      }, 5000);
    },
    // 检查并同步聊天状态
    checkAndSyncChatState() {
      try {
        const orderNumber = store.state.orderNumber;
        const userInfo = store.state.userInfo;
        const statusFlag = store.state.StatusFlag;
        const showMsgFlag = store.state.showMsgFlag;

        // 如果有订单号但聊天界面没显示，自动修复
        if (orderNumber && userInfo && userInfo.name && statusFlag && !showMsgFlag) {
          console.log('检测到状态不一致，自动修复聊天界面显示');
          store.commit("SET_SHOWMSGFLAG", true);
        }
        // 仅当完全无会话且不在接诊中时才隐藏，避免误杀用户手动打开的聊天
        else if (!orderNumber && (!userInfo || !userInfo.name) && !statusFlag && showMsgFlag) {
          console.log('检测到无有效会话且不在接诊，隐藏聊天界面');
          store.commit("SET_SHOWMSGFLAG", false);
        }
      } catch (error) {
        console.error('检查聊天状态失败:', error);
      }
    },
    // 页面激活时恢复聊天状态
    restoreChatStateOnActivation() {
      try {
        const orderNumber = store.state.orderNumber;
        const userInfo = store.state.userInfo;
        const statusFlag = store.state.StatusFlag;

        console.log('页面激活时检查聊天状态:', {
          orderNumber,
          userInfo: userInfo ? {name: userInfo.name, id: userInfo.id} : null,
          statusFlag,
          showMsgFlag: store.state.showMsgFlag
        });

        // 如果有活跃的聊天会话，恢复聊天界面
        if (orderNumber && userInfo && userInfo.name && statusFlag) {
          console.log('检测到活跃聊天会话，恢复聊天界面');
          store.commit("SET_SHOWMSGFLAG", true);

          // 通知 myMain 组件重新加载聊天记录
          this.$nextTick(() => {
            if (this.$refs.mymain) {
              console.log('通知 myMain 组件重新加载聊天记录');
              this.$refs.mymain.refreshChatData();
            }
          });
        } else {
          console.log('无活跃聊天会话，保持聊天界面关闭');
          store.commit("SET_SHOWMSGFLAG", false);
        }
      } catch (error) {
        console.error('恢复聊天状态失败:', error);
      }
    },

    changeData() {
      this.$nextTick(() => {
        this.$forceUpdate();
      });
      if (this.mainDiagFlag != "") {
        this.NullFlag = true;
      }
      if (this.diagType != "") {
        this.NullFlag2 = true;
      }
    },
    socketInit() {
      var that = this;
      if (that.count == 0) {
        var time = new Date();
        that.lockReconnect = false; //重连指示
        that.reconnectFlag = false;
        that.socket_init = new WebSocket(that.socketUrl2); //测试
        let postData = {
          token: localStorage.getItem("token"),
          doctorCode: localStorage.getItem("doctorEmployee"),
        };
        let postData2 = JSON.stringify(postData);
        that.socket_init.onopen = function () {
          setTimeout(() => {
            that.socket_init.send(postData2);
            that.socketFlag = true;
            that.flagTrue = true;
            that.count2 = 0;
          }, 1000);
        };
        that.heartCheckStart = setInterval(function () {
          if (that.flagTrue) {
            that.socket_init.send(postData2);
          } else {
            clearInterval(that.heartCheckStart);
          }
        }, 120000);
        that.socket_init.onmessage = function (evt) {
          let dataObj = JSON.parse(evt.data);
          if (dataObj.data) {
            if (dataObj.data.type == -1) {
              that.reLoadAsideFlag++;
            } else if (dataObj.code == 0) {
              let data = {
                type: 0,
                sendType: dataObj.data.sendType, //发送者id
                receiver: 2, //接收方id
                time: time.toLocaleString(), //发送时间
                contentData: dataObj.data.data, //消息内容
                contentType: dataObj.data.contentType,
              };
              if (dataObj.data.type == "3") {
                if (dataObj.data.doctorCode == localStorage.getItem("doctorEmployee")) {
                  data.type = 3;
                  data.sendType = 2;
                  data.sender = "my";
                  data.receiver = "user";
                  data.contentData = JSON.parse(dataObj.data.data).message;
                  data.orderNumber = dataObj.data.orderNumber;
                } else {
                  that.reLoadAsideFlag--;
                }
              }
              if (dataObj.data.type == "4") {
                that.reLoadAsideFlag--;
                if (dataObj.data.orderNumber == that.userInfo.orderNumber) {
                  // that.errorTipsMsg("该患者已经申请退款，请开始其他接诊");
                  store.commit("SET_SHOWMSGFLAG", false);
                  store.commit("SET_CF_FLAG", false);
                  that.pre_FLag = false;
                }
              }
              if (dataObj.data.type == "5") {
                data.type = 3;
                data.sendType = 2;
                data.sender = "my";
                data.receiver = "user";
                data.contentData = dataObj.data.data;
                data.orderNumber = dataObj.data.orderNumber;
              }
              if (dataObj.data.type == "6") {
                data.type = 6;
                data.contentData = JSON.parse(dataObj.data.data);
              }
              if (dataObj.data.type == "9") {
                that.reLoadAsideFlag--;
                store.commit("SET_SHOWMSGFLAG", false);
              }
              if (dataObj.data.type == "10") {
                data.sendType = 2;
              }
              if (
                  store.state.orderNumber == dataObj.data.orderNumber &&
                  dataObj.data.type != "2" && dataObj.data.type != "9"
              ) {
                //当前页面聊天更新判断;
                if (dataObj.data.contentType == 1) {
                  imgDownLoad({
                    path: dataObj.data.data,
                  }).then((res) => {
                    data.imgUrl = "data:image/jpeg;base64," + res.data;
                    data.sendType = 1;
                    // store.commit("SET_COUNT", 0);
                    store.commit("SOCKET_updateChatMessageList", data);
                  });
                } else {
                  // store.commit("SET_COUNT", 0);
                  store.commit("SOCKET_updateChatMessageList", data);
                }
              }
            }
          }
        };
        that.socket_init.onerror = function () {
          clearInterval(that.heartCheckStart);
          that.initFLag = true;
          that.count2++;
          if (!that.lockReconnect && !that.reconnectFlag) {
            if (that.count2 < 3) {
              that.socketInit();
            } else {
              that.count2 = 0;
            }
          } else {
            that.lockReconnect = false;
          }
        };
        that.socket_init.onclose = function () {
          that.count = 0;
          clearInterval(that.heartCheckStart);
          that.flagTrue = false;
          that.initFLag = true;
          if (!that.lockReconnect && !that.reconnectFlag) {
            that.count2++;
            setTimeout(() => {
              if (that.count2 < 3) {
                that.socketInit();
              } else {
                that.count2 = 0;
              }
            }, 15000);
          } else {
            that.lockReconnect = false;
          }
        };
        that.count++;
      } else {
        that.count = 0;
        if (!that.lockReconnect && !that.reconnectFlag && that.initFLag) {
          setTimeout(() => {
            if (that.count2 < 3) {
              that.socketInit();
              that.count2++;
            } else {
              that.count2 = 0;
            }
          }, 15000);
        }
      }
    },
    handleCurrentChange(val) {
      this.loading2 = true;
      this.medicalCp = val.toString();
      let upData = {
        cp: this.medicalCp,
        lz: 10,
        keyWords: this.search,
        drugType: this.drugTypeFilter,
      };
      upData.id = store.state.surrferId;
      Medicinal_Search(upData).then((data) => {
        if (data.code == 0) {
          if (data.data.drugInfoDTOS) {
            // 根据drugType过滤数据
            this.prescriptionData = data.data.drugInfoDTOS.filter(item => {
              if (this.drugTypeFilter === 2) {
                // 只显示中药
                return item.drugType === 2;
              } else if (this.drugTypeFilter === 1) {
                // 只显示西药
                return item.drugType === 1;
              } else {
                // 显示全部
                return true;
              }
            });

            // 恢复数量状态
            this.restoreQuantityState();

            // 恢复高亮状态，显示已选中的药材
            this.updateSelectRowIndex();
          }
          this.PageCounts = data.data.count - 0;
          this.loading2 = false;

        } else {
          this.errorTipsMsg(data.msg);
          this.loading2 = false;
        }
      });
      this.medicineDialog = true;
    },
    handleCurrentChange2(val) {
      this.loading1 = true;
      let postData = {
        cp: val.toString(),
        lz: 8,
        dictType: "diag_type",
        keyword: this.condition,
        type: this.diagType,
      };
      dictDataList(postData).then((data) => {
        if (data.code == 0) {
          this.dictDataListData = data.data.data;
          this.loading1 = false;
          this.PageCounts2 = data.data.count - 0;
        } else {
          this.errorTipsMsg(data.msg);
          this.loading1 = false;
        }
      });
    },
    handleSizeChange(val) {
    },
    AddDictData(row) {
      debugger
      if (this.mainDiagFlag == "") {
        this.NullFlag = false;
      } else {
        this.NullFlag = true;
      }
      if (this.diagType == "") {
        this.NullFlag2 = false;
      } else {
        this.NullFlag2 = true;
      }
      if (this.NullFlag && this.NullFlag2) {
        let data = {
          diagCode: row.diagnosisCode,
          diagName: row.diagnosisName,
          diagSrtNo: "",
          diagType: this.diagType,
          mainDiagFlag: this.mainDiagFlag,
        };

        this.addFlag = true;
        this.prescriptionDiseInfoQOList.forEach((item) => {
          if (item.diagCode == data.diagCode) {
            this.addFlag = false;
          }
        });
        if (this.addFlag) {
          this.prescriptionDiseInfoQOList.push(data);

          // 当选择门诊中药饮片时，添加诊断后不关闭弹窗，需要继续选择中医证候
          if (this.rxTypeCode === '2' && this.diagType === '2') {
            this.$message({
              message: '已添加中医诊断，请继续选择中医证候',
              type: 'success',
              duration: 2000
            });
            this.diagType = "3";
            // 清空搜索数据，让用户重新搜索中医证候
            this.dictDataListData = [];
            this.condition = "";
          } else {
            this.prescriptionDiseInfoQO = false;
          }
        } else {
          this.errorTipsMsg("请勿重复添加相同诊断");
        }
        // if(this.prescriptionDiseInfoQOList.length>0&&data.mainDiagFlag == 1){
        //   this.errorTipsMsg("诊断列表中只能存在一个主诊断标志");
        // }else{
        //   }
      }
    },
    searchList() {
      this.loading1 = true;
      let postData = {
        cp: "1",
        lz: "8",
        dictType: "diag_type",
        keyword: this.condition,
        type: this.diagType,
      };
      dictDataList(postData).then((data) => {
        if (data.code == 0) {
          this.dictDataListData = data.data.data;
          this.loading1 = false;
          this.PageCounts2 = data.data.count - 0;
        } else {
          this.errorTipsMsg(data.msg);
          this.loading1 = false;
        }
      });
    },
    deleteRow(rows, index) {
      this.prescriptionDiseInfoQOList.splice(index, 1);
    },

    // 新增诊断行
    addNewDiagnosis() {
      console.log('点击新增诊断，当前诊断列表长度:', this.prescriptionDiseInfoQOList.length);
      const newDiagnosis = {
        diagCode: "",
        diagName: "",
        diagSrtNo: this.prescriptionDiseInfoQOList.length + 1,
        diagType: this.rxTypeCode === '2' ? "2" : "1", // 中医默认中医诊断，西医默认西医诊断
        mainDiagFlag: "1",
        sympCode: "",
        sympName: "",
        diagnosisOptions: [], // 诊断选项
        diagnosisLoading: false, // 加载状态
        syndromeOptions: [], // 证候选项
        syndromeLoading: false // 证候加载状态
      };
      this.prescriptionDiseInfoQOList.push(newDiagnosis);
      console.log('新增诊断后，诊断列表长度:', this.prescriptionDiseInfoQOList.length);
      console.log('新增的诊断记录:', newDiagnosis);
      this.$message.warning('请选择相关诊断');
    },

    // 删除诊断行
    deleteDiagnosisRow(index) {
      this.prescriptionDiseInfoQOList.splice(index, 1);
      // 重新编号
      this.prescriptionDiseInfoQOList.forEach((item, idx) => {
        item.diagSrtNo = idx + 1;
      });
    },

    searchDiagnosisAutocomplete(query, callback, rowIndex) {
      if (!query) {
        callback([]);
        return;
      }

      const postData = {
        cp: "1",
        lz: "50",
        dictType: "diag_type",
        keyword: query,
        type: this.prescriptionDiseInfoQOList[rowIndex].diagType
      };

      dictDataList(postData).then((response) => {
        if (response.code === 0) {
          const dataList = response.data.data || [];

          // 格式化数据
          const suggestions = dataList.map(item => ({
            value: item.diagnosisName,
            dictLabel: item.diagnosisName,
            dictValue: item.diagnosisCode
          }));

          callback(suggestions);
        } else {
          callback([]);
          this.$message.error(response.msg || '搜索失败');
        }
      }).catch((error) => {
        console.error('搜索诊断失败:', error);
        callback([]);
        this.$message.error('搜索失败');
      });
    },

    // 诊断自动完成选择
    onDiagnosisAutocompleteSelect(item, row, index) {
      // 兼容 InputLoadMore 组件和原有 el-autocomplete 的数据格式
      row.diagName = item.value || item.dictLabel;  // 使用value字段或dictLabel
      row.diagCode = item.code || item.dictValue;   // 使用code字段或dictValue
    },
    searchSyndromeAutocomplete(query, callback, rowIndex) {
      if (!query || query.length < 1) {
        callback([]);
        return;
      }

      const postData = {
        cp: "1",
        lz: "50",
        dictType: 'diag_type',
        keyword: query,
        type: '4' // 4-中医证候
      };

      dictDataList(postData).then((response) => {
        if (response.code === 0) {
          const dataList = response.data.data || [];

          // 格式化数据
          const suggestions = dataList.map(item => ({
            value: item.diagnosisName,
            dictLabel: item.diagnosisName,
            dictValue: item.diagnosisCode
          }));

          callback(suggestions);
        } else {
          callback([]);
          this.$message.error(response.msg || '搜索证候失败');
        }
      }).catch((error) => {
        console.error('搜索证候失败:', error);
        callback([]);
        this.$message.error('搜索证候失败');
      });
    },

    // 证候自动完成选择
    onSyndromeAutocompleteSelect(item, row, index) {
      // 兼容 InputLoadMore 组件和原有 el-autocomplete 的数据格式
      row.sympName = item.value || item.dictLabel;  // 使用value字段或dictLabel
      row.sympCode = item.code || item.dictValue;   // 使用code字段或dictValue
      console.log('选择了证候:', item);
      console.log('设置证候编码:', row.sympCode, '证候名称:', row.sympName);
    },

    // 诊断下拉框失去焦点
    onDiagnosisBlur(row, index) {
      // 如果用户输入了内容但没有选择任何选项，保留输入的内容
      if (row.diagName && !row.diagCode) {
        console.log('用户输入了诊断名称但没有选择:', row.diagName);
      }
    },

    // 证候输入框失去焦点
    onSyndromeBlur(row, index) {
      // 如果用户输入了内容但没有选择任何选项，尝试通过名称匹配设置编码
      if (row.sympName && !row.sympCode) {
        console.log('用户输入了证候名称但没有选择:', row.sympName);
        // 尝试通过证候名称搜索并设置编码
        this.searchAndSetSyndromeCode(row.sympName, row);
      }
    },
    // 智能解析证候名称
    parseSyndromeNames(illDesc) {
      if (!illDesc) return [];

      // 按逗号分割
      const parts = illDesc.split(/[\s,，]+/).filter(item => item.trim() !== '');

      // 如果分割后只有一个部分，且包含"证"字，可能是完整证候
      if (parts.length === 1 && parts[0].includes('证') && parts[0].length > 6) {
        return [parts[0]]; // 作为完整证候处理
      }

      // 智能合并证候：如果某个部分不包含"证"字，且下一个部分包含"证"字，则合并
      const result = [];
      for (let i = 0; i < parts.length; i++) {
        let currentPart = parts[i].trim();

        // 如果当前部分不包含"证"字，且下一个部分包含"证"字，则合并
        if (!currentPart.includes('证') && i + 1 < parts.length && parts[i + 1].includes('证')) {
          currentPart = currentPart + '，' + parts[i + 1].trim();
          i++; // 跳过下一个部分，因为已经合并了
        }

        result.push(currentPart);
      }

      return result;
    },

    // 通过证候名称搜索并设置编码
    searchAndSetSyndromeCode(syndromeName, row) {
      const postData = {
        cp: '1',
        lz: '8',
        dictType: 'diag_type',
        keyword: syndromeName,
        type: '4' // 4-中医证候
      };

      dictDataList(postData).then((response) => {
        if (response.code === 0 && response.data.data && response.data.data.length > 0) {
          // 查找完全匹配的证候
          const exactMatch = response.data.data.find(item => item.diagnosisName === syndromeName);
          if (exactMatch) {
            row.sympCode = exactMatch.diagnosisCode;
            console.log('通过名称匹配设置证候编码:', row.sympCode, '证候名称:', row.sympName);
          } else {
            console.log('未找到完全匹配的证候编码');
          }
        }
      }).catch((error) => {
        console.error('搜索证候编码失败:', error);
      });
    },

    // 诊断类别变化
    onDiagTypeChange(row) {
      // 清空诊断名称和选项
      row.diagName = "";
      row.diagCode = "";
      row.diagnosisOptions = [];

      // 清空中医证候相关字段
      row.sympName = "";
      row.sympCode = "";
      row.syndromeOptions = [];
    },
    avatar(src) {
      this.choosed = src;
    },
    delMedicinal(row, index) {
      this.formParams.tableData.splice(index, 1);
      // 如果是中药，重新计算单副金额
      if (this.rxTypeCode === '2') {
        this.calculateChineseMedicineSinglePrice();
        this.calculateTotalPrice();
      }
    },
    login() {
      if (this.username && this.choosed) {
        /* 连接socket */
        this.$socket.connect();
      }
    },
    loadOrderDrugList() {
      this.formParams.tableData = store.state.orderDrugList;
    },
    getMedicineList() {
      this.search = "";

      // 根据处方类别自动设置药品类型过滤参数
      if (this.rxTypeCode === '2') {
        // 门诊中药饮片 - 设置中药筛选参数
        this.drugTypeFilter = 2;
      } else {
        // 门诊西药 - 设置西药筛选参数
        this.drugTypeFilter = 1;
      }

      // 中药处方没有药品数量限制，西药处方限制5种
      const maxDrugs = this.rxTypeCode === '2' ? 999 : 5;
      if (this.formParams.tableData.length < maxDrugs) {
        // this.loading2 = true;
        // let upData = {
        //   cp: "1",
        //   lz: "8",
        // };
        // upData.id = store.state.surrferId;
        // Medicinal_Search(upData).then((data) => {
        //   if (data.code == 0) {
        //     if (data.data.drugInfoDTOS) {
        //       this.prescriptionData = data.data.drugInfoDTOS;
        //     }
        //     this.PageCounts = data.data.count - 0;
        //     this.loading2 = false;
        //   } else {
        //     this.errorTipsMsg(data.msg);
        //     this.loading2 = false;
        //   }
        // });
        this.medicineDialog = true;
      } else {
        // 根据处方类型显示不同的错误提示
        const errorMsg = this.rxTypeCode === '2' ? "药品数量已达上限" : "最多开五种药品";
        this.errorTipsMsg(errorMsg);
      }
    },
    searchMedicineList() {
      // 如果搜索框为空，清空数据并返回
      if (!this.search) {
        this.prescriptionData = [];
        this.PageCounts = 0;
        return;
      }
      // 中药处方没有药品数量限制，西药处方限制5种
      const maxDrugs = this.rxTypeCode === '2' ? 999 : 5;
      if (this.formParams.tableData.length < maxDrugs) {
        this.medicalCp = 1;
        this.loading2 = true;
        let upData = {
          cp: this.medicalCp,
          lz: 10,
          keyWords: this.search,
          drugType: this.drugTypeFilter, // 传递药品类型参数给后端进行筛选
        };
        upData.id = store.state.surrferId;
        Medicinal_Search(upData).then((data) => {
          if (data.code == 0) {
            if (data.data.drugInfoDTOS) {
              // 直接使用后端返回的已筛选数据
              this.prescriptionData = data.data.drugInfoDTOS;

              // 恢复数量状态
              this.restoreQuantityState();

              // 恢复高亮状态，显示已选中的药材
              this.updateSelectRowIndex();
            }
            this.PageCounts = data.data.count - 0;
            this.loading2 = false;

          } else {
            this.errorTipsMsg(data.msg);
            this.loading2 = false;
          }
        });
        this.medicineDialog = true;
      } else {
        // 根据处方类型显示不同的错误提示
        const errorMsg = this.rxTypeCode === '2' ? "药品数量已达上限" : "最多开五种药品";
        this.errorTipsMsg(errorMsg);
      }
    },
    // 处理表格行点击事件
    handleRowClick(row) {
      if (this.rxTypeCode === '2') {
        // 中药：多选模式，点击行切换复选框状态
        this.toggleRowSelection(row);
      } else {
        // 西药：原有的单选模式
        this.AddMedicinal(row);
      }
    },
    // 处理表格选中状态变化
    handleSelectionChange(selection) {
      if (this.rxTypeCode === '2') {
        // 中药：保留数量信息和备注信息，更新选中数据
        this.selectedMedicineIds.clear();
        this.selectedChineseMedicines = selection.map(item => {
          // 优先使用保存的数量，如果没有则使用当前数量，最后使用默认值
          const savedQuantity = this.quantityStorage.get(item.drugCode);
          if (savedQuantity) {
            item.selectedQuantity = savedQuantity;
          } else if (!item.selectedQuantity) {
            item.selectedQuantity = 1; // 默认数量
          }
          
          // 优先使用保存的备注，如果没有则使用当前备注
          const savedRemark = this.remarkStorage.get(item.drugCode);
          if (savedRemark) {
            item.remarkWayName = savedRemark;
          } else if (!item.remarkWayName) {
            // 如果表格中没有备注，尝试从外部卡片中读取
            const cardItem = this.formParams.tableData.find(card => card.drugCode === item.drugCode);
            if (cardItem && cardItem.wayName) {
              item.remarkWayName = cardItem.wayName;
            }
          }
          
          this.selectedMedicineIds.add(item.drugCode);
          return item;
        });
      }
    },
    // 切换行选择状态
    toggleRowSelection(row) {
      if (this.rxTypeCode === '2') {
        // 中药模式下，切换行的选中状态
        const isSelected = this.selectedMedicineIds.has(row.drugCode);
        if (isSelected) {
          // 如果已选中，则取消选中
          this.$refs.medicineTable.toggleRowSelection(row, false);
        } else {
          // 如果未选中，则选中
          this.$refs.medicineTable.toggleRowSelection(row, true);
        }
      }
    },
    // 更新选中药品的数量
    updateSelectedQuantity(row) {
      // 确保数量有默认值
      if (!row.selectedQuantity) {
        row.selectedQuantity = 1; // 默认数量
      }

      // 保存数量到storage中
      this.quantityStorage.set(row.drugCode, row.selectedQuantity);

      // 当用户设置数量时，自动勾选该行
      if (row.selectedQuantity && row.selectedQuantity > 0) {
        // 使用$nextTick确保DOM更新后再执行勾选
        this.$nextTick(() => {
          this.$refs.medicineTable.toggleRowSelection(row, true);
        });
      }

      // 如果该药品已被选中，更新选中列表中的数量
      const selectedIndex = this.selectedChineseMedicines.findIndex(item => item.drugCode === row.drugCode);
      if (selectedIndex !== -1) {
        this.selectedChineseMedicines[selectedIndex].selectedQuantity = row.selectedQuantity;
      }

      // 如果该药品已经在外部卡片中，同步更新外部卡片的数量
      const cardIndex = this.formParams.tableData.findIndex(item => item.drugCode === row.drugCode);
      if (cardIndex !== -1) {
        this.formParams.tableData[cardIndex].drugNumber = row.selectedQuantity;
        // 触发天数更新
        this.updateDays(cardIndex);
      }
    },
    // 处理数量选择框获得焦点
    handleQuantitySelectFocus(row) {
      // 初始化数量相关属性
      if (!row.selectedQuantity) {
        row.selectedQuantity = 1; // 默认数量
      }
    },
    // 更新备注并同步到外部卡片
    updateRemarkWayName(row) {
      // 保存备注到storage中
      this.remarkStorage.set(row.drugCode, row.remarkWayName);

      // 如果该药品已被选中，更新选中列表中的备注
      const selectedIndex = this.selectedChineseMedicines.findIndex(item => item.drugCode === row.drugCode);
      if (selectedIndex !== -1) {
        this.selectedChineseMedicines[selectedIndex].remarkWayName = row.remarkWayName;
      }

      // 如果该药品已经在外部卡片中，同步更新外部卡片的备注
      const cardIndex = this.formParams.tableData.findIndex(item => item.drugCode === row.drugCode);
      if (cardIndex !== -1) {
        this.formParams.tableData[cardIndex].wayName = row.remarkWayName;
      }
    },
    // 恢复数量状态和备注状态
    restoreQuantityState() {
      if (this.rxTypeCode === '2') {
        // 只对中药恢复数量状态和备注状态
        this.prescriptionData.forEach(item => {
          // 恢复数量
          const savedQuantity = this.quantityStorage.get(item.drugCode);
          if (savedQuantity) {
            item.selectedQuantity = savedQuantity;
          } else {
            // 所有中药都设置默认数量为1
            item.selectedQuantity = 1;
          }
          
          // 恢复备注：优先从外部卡片中读取，如果没有则从存储中读取
          const cardItem = this.formParams.tableData.find(card => card.drugCode === item.drugCode);
          if (cardItem && cardItem.wayName) {
            item.remarkWayName = cardItem.wayName;
            this.remarkStorage.set(item.drugCode, cardItem.wayName);
          } else {
            const savedRemark = this.remarkStorage.get(item.drugCode);
            if (savedRemark) {
              item.remarkWayName = savedRemark;
            }
          }
        });
      }
    },
    // 批量添加中药
    batchAddChineseMedicines() {
      if (this.selectedChineseMedicines.length === 0) {
        this.errorTipsMsg("请先选择要添加的药材");
        return;
      }

      let addedCount = 0;
      let duplicateCount = 0;

      this.selectedChineseMedicines.forEach(row => {
        // 检查是否已存在
        let exists = false;
        this.formParams.tableData.forEach((item) => {
          if (item.drugCode == row.drugCode) {
            exists = true;
          }
        });

        if (!exists) {
          let data = {
            drugName: row.drugName,
            drugCode: row.drugCode,
            specification: row.specification,
            drugPayPrice: row.onlineRetailPrice,
            frquName: row.frquName,
            wayName: row.remarkWayName  || '',
            drugNumber: row.selectedQuantity || 10,
            commodityName: row.commodityName,
            genericName: row.genericName,
            minPackageQuantity: row.minPackageQuantity,
            minPreparationUnit: row.minPreparationUnit,
            minPackageUnit: row.minPackageUnit,
            barCode: row.barCode,
            usageAndDosage: row.usageAndDosage,
            frquCode: row.frquCode,
            wayCode: row.wayCode,
            sinDoscnt: row.sinDoscnt,
            sinDosunt: row.sinDosunt,
            originalDays: row.days,
            days: row.days
          };

          this.formParams.tableData.push(data);
          addedCount++;
        } else {
          duplicateCount++;
        }
      });

      // 清空选中状态
      this.selectedChineseMedicines = [];
      this.selectedMedicineIds.clear();
      this.selectRow = []; // 清空高亮行索引
      this.quantityStorage.clear(); // 清空数量存储
      this.remarkStorage.clear(); // 清空备注存储

      // 清空表格选中状态
      if (this.$refs.medicineTable) {
        this.$refs.medicineTable.clearSelection();
      }

      // 关闭弹窗
      this.medicineDialog = false;

      // 重新计算单副金额
      this.calculateChineseMedicineSinglePrice();
      this.calculateTotalPrice();

      // 显示结果提示
      if (addedCount > 0) {
        this.$message({
          message: `成功添加 ${addedCount} 味药材${duplicateCount > 0 ? `，${duplicateCount} 味药材已存在` : ''}`,
          type: "success",
          duration: 3000
        });
      } else {
        this.errorTipsMsg("所选药材均已存在，请勿重复添加");
      }
    },
    AddMedicinal(row) {
      if (row.validMark != 1) {
        this.errorTipsMsg("该医保编码无效，请重新选择");
        return;
      }
      // 中药处方没有药品数量限制，西药处方限制5种
      const maxDrugs = this.rxTypeCode === '2' ? 999 : 5;
      if (this.formParams.tableData.length < maxDrugs) {
        let flag = true;
        this.formParams.tableData.forEach((item) => {
          if (item.drugCode == row.drugCode) {
            flag = false;
          }
        });
        if (flag) {
          let data = {
            drugName: row.drugName,
            drugCode: row.drugCode,
            specification: row.specification,
            drugPayPrice: row.onlineRetailPrice,
            frquName: row.frquName,
            wayName: row.remarkWayName  || '',
            drugNumber: 1,
            commodityName: row.commodityName,
            genericName: row.genericName,
            minPackageQuantity: row.minPackageQuantity,
            minPreparationUnit: row.minPreparationUnit,
            minPackageUnit: row.minPackageUnit,
            barCode: row.barCode,
            usageAndDosage: row.usageAndDosage,
            frquCode: row.frquCode,
            wayCode: row.wayCode,
            sinDoscnt: row.sinDoscnt,
            sinDosunt: row.sinDosunt,
            originalDays: row.days,
            days: row.days
          };

          this.formParams.tableData.push(data);
          this.medicineDialog = false;

          // 如果是中药，重新计算单副金额
          if (this.rxTypeCode === '2') {
            this.calculateChineseMedicineSinglePrice();
            this.calculateTotalPrice();
          }

          // 显示成功提示
          this.$message({
            message: `已添加药品：${row.drugName}`,
            type: "success",
            duration: 2000
          });
        } else {
          this.errorTipsMsg("您已添加该药品，请勿重复添加");
        }
      } else {
        // 根据处方类型显示不同的错误提示
        const errorMsg = this.rxTypeCode === '2' ? "药品数量已达上限" : "最多开五种药品";
        this.errorTipsMsg(errorMsg);
      }
    },
    queryPsn() {
      this.loading4 = true
      request({
        url: `http://localhost:18665/ec/query`,
        method: 'get',
        params: {type: 1}
      }).then((data) => {
        this.loading4 = false
        if (data.code == 0) {
          this.mdtrtCertType = "01"
          this.mdtrtCertNo = data.data.ecToken
        } else {
          this.errorTipsMsg(data.msg);
        }
      })
    },

    executeExtraction() {
      // 始终以缓存中的prescrKind为准
      const prescrKind = localStorage.getItem('prescrKind');
      let rxTypeCode;

      // 根据缓存中的prescrKind设置处方类别
      if (prescrKind === '1') {
        rxTypeCode = '1'; // 门诊西药
      } else if (prescrKind === '2') {
        rxTypeCode = '2'; // 门诊中药饮片
      } else {
        // 如果缓存中没有prescrKind，则使用界面上的选择作为默认值
        rxTypeCode = this.rxTypeCode;
      }

      this.extractionLoading = true;
      let loadingChange = setTimeout(() => {
        this.extractionLoading = false;
      }, 10000);
      this.prescriptionDiseInfoQOList.map((item, index) => {
        item.diagSrtNo = index + 1;
      });
      let postData = {
        id: store.state.surrferId,
        note: this.note,
        prescriptionDrugQOList: [],
        prescriptionDiseInfoQOList: this.prescriptionDiseInfoQOList,
        rxTypeCode: rxTypeCode,
        mdtrtCertType: this.mdtrtCertType,
        mdtrtCertNo: this.mdtrtCertNo
      };
      if (this.diseName !== null && this.diseName !== '' && typeof this.diseName === 'string') {
        try {
          let diseName = JSON.parse(this.diseName);
          if (diseName.expContent == 11) {
            postData.medType = "140104";
          } else {
            postData.medType = "140201";
          }
          postData.diseCode = diseName.diseCode;
          postData.diseName = diseName.diseName;
        } catch (e) {
          console.error('解析慢特病信息失败:', e);
        }
      } else if (this.opspEchoInfo) {
        if (this.opspEchoInfo.expContent == 11) {
          postData.medType = "140104";
        } else {
          postData.medType = "140201";
        }
        postData.diseCode = this.opspEchoInfo.diseCode;
        postData.diseName = this.opspEchoInfo.diseName;
      } else {
        postData.medType = "11";
      }
      if (this.inHospFlag) {
        postData.medType = "910101";
      }
      if (rxTypeCode === '2') {
        postData.num = this.num,
            postData.wayName = this.wayName,
            postData.frquName = this.frquName,
            postData.frquNum = this.frquNum,
            postData.frquPreNum = this.frquPreNum,
            postData.sinDoscnt = this.sinDoscnt,
            postData.sinDosunt = this.sinDosunt,
            postData.usageTime = this.usageTime,
            postData.drugType = this.drugType,
            postData.decoctingMethod = this.decoctingMethod,

            postData.prescriptionDiseInfoQOList = this.prescriptionDiseInfoQOList.map(item => ({
              diagCode: item.diagCode,
              diagName: item.diagName,
              diagSrtNo: item.diagSrtNo,
              diagType: item.diagType,
              mainDiagFlag: item.mainDiagFlag,
              sympCode: item.sympCode,
              sympName: item.sympName,
            }))


        if (this.formParams.tableData.length > 0) {
          postData.prescriptionDrugQOList = this.formParams.tableData.map((item, index) => ({
            days: item.days,
            drugCode: item.drugCode,
            drugName: item.drugName,
            frquCode: item.frquCode,
            frquName: item.frquName,
            number: item.drugNumber,
            sinDoscnt: item.sinDoscnt,
            sinDosunt: item.sinDosunt,
            wayCode: item.wayCode,
            wayName: item.wayName
          }));
        }
      }
      if (this.rxTypeCode === '1') {
        this.formParams.tableData.forEach((item, index) => {
          postData.prescriptionDrugQOList.push({
            drugCode: "",
            drugName: "",
            frquCode: "",
            frquName: "",
            number: "",
            wayCode: "",
            wayName: "",
            days: "",
            sinDoscnt: "",
            sinDosunt: "",
          });
          postData.prescriptionDrugQOList[index].drugCode = item.drugCode;
          postData.prescriptionDrugQOList[index].drugName = item.drugName;
          postData.prescriptionDrugQOList[index].frquName = item.frquName;
          postData.prescriptionDrugQOList[index].frquCode = item.frquCode;
          postData.prescriptionDrugQOList[index].wayCode = item.wayCode;
          postData.prescriptionDrugQOList[index].wayName = item.wayName;
          postData.prescriptionDrugQOList[index].number = item.drugNumber;
          postData.prescriptionDrugQOList[index].days = item.days;
          postData.prescriptionDrugQOList[index].sinDoscnt = item.sinDoscnt;
          postData.prescriptionDrugQOList[index].sinDosunt = item.sinDosunt;
        });
      }
      Extraction(postData).then((data) => {
        if (data.code != 0) {
          this.errorTipsMsg(data.msg);
          this.loading3 = false;
        } else {
          this.loading3 = true;
          let time = new Date();
          time = time.toLocaleString();
          let extractionData = JSON.parse(JSON.stringify(postData));
          extractionData.time = time;
          extractionData.extractionFlag = true;
          extractionData.type = "my";
          extractionData.orderNumber = store.state.orderNumber;
          this.formParams.tableData.forEach((item, index) => {
            extractionData.prescriptionDrugQOList[index].specification =
                item.specification;
          });
          if (
              data.data.selfSign == "true" ||
              data.data.selfSign == "true"
          ) {
            this.errorTipsMsg("请尽快结束该问诊");
          } else {
            this.errorTipsMsg("您当前尚未开启自动签，请及时对处方签名");
          }
          store.commit("SET_CF_FLAG", this.CF_Flag);
          this.loading3 = false;
          this.diseName = [];
          this.diseOptions = [];
          this.diseFlag.display = 'none';
          this.inHospFlag = false;
          this.opspEchoInfo = null;
        }
        this.extractionLoading = false;
        clearTimeout(loadingChange);
      });
    },
    extraction() {
      if (this.isTraditionalChineseMedicine) {
        this.executeExtraction();
        return;
      }
      // this.submitForm("ruleForm");
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            this.executeExtraction();
          }
        });
      } else {
        this.executeExtraction();
      }
    },
    frquNameChange(index, id) {
      let dir = this.frquOptions.find((item) => item.value === id);
      this.formParams.tableData[index].frquName = dir.label;
    },
    wayNameChange(index, id) {
      let dir = this.wayOptions.find((item) => item.value === id);
      this.formParams.tableData[index].wayName = dir.label;
    },
    errorTipsMsg(str) {
      this.tipsFlag2 = true;
      this.tipsMsg = str;
      setTimeout(() => {
        this.tipsFlag2 = false;
      }, 2000);
    },
    openPrescriptionDiseInfoQO() {
      this.dictDataListData = [];
      this.mainDiagFlag = "1";
      if (this.rxTypeCode === '2') {
        this.diagType = "2"; // 2表示中医诊断
      } else {
        this.diagType = "1"; // 1表示西医诊断
      }
      // if (this.prescriptionDiseInfoQOList.length > 0) {
      //   this.mainDiagFlag = "0";
      //   var changeFLag = true;
      //   this.prescriptionDiseInfoQOList.forEach((item) => {
      //     if (item.mainDiagFlag == 1) {
      //       changeFLag = false;
      //     }
      //   });
      //   if (changeFLag) {
      //     this.mainDiagFlag = "1";
      //   } else {
      //     this.mainDiagFlag = "0";
      //   }
      // } else {
      //   this.mainDiagFlag = "1";
      // }
      this.condition = "";
      this.prescriptionDiseInfoQO = true;
    },
    tableRowClassName({row, rowIndex}) {
      row.index = rowIndex;
      return '';
    },
    // 设置行样式，实现选中行高亮
    rowClass({row, rowIndex}) {
      if (this.rxTypeCode === '2' && this.selectRow.includes(rowIndex)) {
        return {"background": "#ecf5ff", "color": "#0caf60"};
      }
      return {};
    },
    // 更新选中行索引
    updateSelectRowIndex() {
      this.selectRow = [];
      if (this.selectedChineseMedicines.length > 0) {
        this.selectedChineseMedicines.forEach((item) => {
          const index = this.prescriptionData.findIndex(row => row.drugCode === item.drugCode);
          if (index !== -1) {
            this.selectRow.push(index);
          }
        });
      }
    },
    // 获取行的唯一标识
    getRowKey(row, index) {
      return row.id;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitFlag = true;
          return true;
        } else {
          this.submitFlag = false;
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    remoteMethod(query) {
      this.PharmacyCp = 1;
      this.PharmacyKeyWord = query;
      let postData = {
        lz: 8,
        cp: this.PharmacyCp,
        keyWord: query,
        dictType: "",
      };
    },
    async StartOrOver(data) {
      this.startEventFlag = false;
      let sufferer = {};
      sufferer.id = data.id;
      if (data.startTime === null) {
        await Treated(sufferer).then((query) => {
          if (query.code == 0) {
            store.commit("SET_SURRFERID", sufferer.id);
            store.commit("SET_ORDERNUMBER", data.orderNumber);
            data.startTime = "1";
            this.showMsgFlag = true;
            this.StatusFlag = true;
            // store.commit("SET_COUNT", 0);
            this.startEventFlag = true;
            store.commit("SET_STATUSFLAG", this.StatusFlag);
            store.commit("SET_SHOWMSGFLAG", this.showMsgFlag);
            this.reLoadAsideFlag--;
          } else {
            this.errorTipsMsg(query.msg);
          }
        });
      } else {
        overOrder(sufferer).then((data2) => {
          if (data2.code == 0) {
            localStorage.removeItem(data.orderNumber);
            this.showMsgFlag = false;
            this.StatusFlag = false;
            this.startEventFlag = true;
            store.commit("SET_STATUSFLAG", this.StatusFlag);
            store.commit("SET_SHOWMSGFLAG", this.showMsgFlag);
            store.commit("SET_ORDERNUMBER", "");
            this.reLoadAsideFlag--;
          } else {
            this.errorTipsMsg(data2.msg);
          }
        });
      }
      this.numberFlag = 1;
    },
    opspReg() {
      let postData = {
        hospitalCode: store.state.userInfo && store.state.userInfo.hospitalCode,
        name: store.state.userInfo && store.state.userInfo.name,
        idNo: store.state.userInfo && store.state.userInfo.idNo
      };
      this.recommendDiseOptions = []
      queryPsnOpspReg(postData).then((data) => {
        if (data.code === 0) {
          if (data.data == null || data.data.length === 0) {
            this.$message.error("暂未查询到慢特病备案记录");
          } else {
            const uniqueDiseSet = new Set();
            data.data.forEach(res => {
              const diseTypeCode = JSON.parse(res.exp_content).diseTypeCode;
              let recommendDise = {
                diseCode: res.opsp_dise_code,
                diseName: res.opsp_dise_name,
                expContent: diseTypeCode
              }
              const uniqueKey = `${recommendDise.diseCode}-${diseTypeCode}`;
              if (!uniqueDiseSet.has(uniqueKey)) {
                uniqueDiseSet.add(uniqueKey);
                this.recommendDiseOptions.push(recommendDise);
              }
            });
            this.diseFlag.display = '';
          }
        } else {
          this.errorTipsMsg(data.msg);
        }
      });
    },
    inhosp() {
      if (this.inHospFlag) {
        this.inHospFlag = false;
      } else {
        let postData = {
          hospitalCode: store.state.userInfo && store.state.userInfo.hospitalCode,
          name: store.state.userInfo && store.state.userInfo.name,
          idNo: store.state.userInfo && store.state.userInfo.idNo
        };
        queryInHospInfo(postData).then((data) => {
          if (data.code === 0) {
            if (data.data == null || data.data.length === 0) {
              this.$message.error("暂未查询到住院信息");
            } else {
              this.inHospFlag = true;
            }
          } else {
            this.errorTipsMsg(data.msg);
          }
        });
      }
    },
    refusePre(data) {
      this.refundForm.id = data.id;
      this.refundForm.reasonCode = "";
      this.refundForm.desc = "";
      this.refundVisible = true;
    },
    refundEvent() {
      this.$refs["refundForm"].validate((valid) => {
        if (valid) {
          this.buttonLoading = true;
          setTimeout(() => {
            this.buttonLoading = false;
          }, 10000);
          refuse(this.refundForm).then((data) => {
            if (data.code != 0) {
              this.errorTipsMsg(data.msg);
            } else {
              this.refundVisible = false;
              this.$message({
                type: "success",
                message: "驳回成功",
              });
            }
            this.buttonLoading = false;
          });
        }
      });
    },
    clearDiseOptions(callback) {
      if (!callback) {
        this.diseOptions = [];
      } else {
        this.diseOptions = this.recommendDiseOptions;
      }
    },
    startFooterDrag(event) {
      this.isFooterDragging = true;
      this.footerStartY = event.clientY;
      this.footerStartHeight = this.$refs.chatFooter.$el.offsetHeight;
      console.log('起始位置:', this.footerStartY, '起始高度:', this.footerStartHeight);
      // 添加拖拽样式
      this.$refs.chatFooter.$el.classList.add('dragging');
      // 禁用页面滚动
      document.body.style.overflow = 'hidden';
      document.body.style.userSelect = 'none';
      document.body.classList.add('dragging-footer');

      // 添加全局事件监听
      document.addEventListener('mousemove', this.onFooterDrag, {passive: false});
      document.addEventListener('mouseup', this.stopFooterDrag, {passive: false});

      // 防止文本选择和事件冒泡
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      // 阻止默认的浏览器行为
      return false;
    },

    // footer拖拽中
    onFooterDrag(event) {
      if (!this.isFooterDragging) return;

      // 阻止默认行为和事件冒泡
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const deltaY = this.footerStartY - event.clientY; // 向上拖拽为正数
      const newHeight = Math.max(this.footerMinHeight, Math.min(this.footerMaxHeight, this.footerStartHeight + deltaY));

      console.log('拖拽中 - deltaY:', deltaY, '新高度:', newHeight);

      // 设置footer高度（使用!important覆盖CSS规则）
      this.$refs.chatFooter.$el.style.setProperty('height', newHeight + 'px', 'important');

      // 触发窗口重新计算布局
      window.dispatchEvent(new Event('resize'));

      // 阻止默认的浏览器行为
      return false;
    },

    // 停止footer拖拽
    stopFooterDrag(event) {
      console.log('停止拖拽footer');
      this.isFooterDragging = false;

      // 移除拖拽样式
      if (this.$refs.chatFooter && this.$refs.chatFooter.$el) {
        this.$refs.chatFooter.$el.classList.remove('dragging');

        // 保存当前高度到本地存储
        const currentHeight = this.$refs.chatFooter.$el.offsetHeight;
        localStorage.setItem('chatFooterHeight', currentHeight);
        console.log('保存footer高度:', currentHeight);
      }

      // 恢复页面滚动
      document.body.style.overflow = '';
      document.body.style.userSelect = '';
      document.body.classList.remove('dragging-footer');

      // 移除全局事件监听
      document.removeEventListener('mousemove', this.onFooterDrag);
      document.removeEventListener('mouseup', this.stopFooterDrag);

      // 阻止事件冒泡
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    },

    // 绑定footer拖拽事件
    bindFooterDragEvents() {
      if (this.$refs.chatFooter && this.$refs.chatFooter.$el) {
        const footerEl = this.$refs.chatFooter.$el;
        // 解绑旧事件
        footerEl.removeEventListener('mousedown', this._footerMouseDownHandler);
        // 定义命中检测处理器（缓存到实例用于解绑）
        this._footerMouseDownHandler = (e) => {
          try {
            const rect = footerEl.getBoundingClientRect();
            const offsetY = e.clientY - rect.top;
            const offsetX = e.clientX - rect.left;
            // 仅当点击在顶部 active 区域内，且不在左右安全区时才启动拖拽
            const inTopBand = offsetY >= 0 && offsetY <= this.footerActiveZoneHeight;
            const inLeftSafe = offsetX >= 0 && offsetX <= this.footerActiveLeftSafe;
            const inRightSafe = offsetX >= rect.width - this.footerActiveRightSafe && offsetX <= rect.width;
            if (inTopBand && !inLeftSafe && !inRightSafe) {
              this.startFooterDrag(e);
            }
          } catch (err) {
          }
        };
        footerEl.addEventListener('mousedown', this._footerMouseDownHandler, {passive: false});
      }
    },

    // 恢复保存的footer高度
    restoreFooterHeight() {
      const savedHeight = localStorage.getItem('chatFooterHeight');
      if (savedHeight && this.$refs.chatFooter) {
        const height = parseInt(savedHeight);
        if (height >= this.footerMinHeight && height <= this.footerMaxHeight) {
          this.$refs.chatFooter.$el.style.setProperty('height', height + 'px', 'important');
        }
      }
      // 如果没有保存的高度，使用CSS默认的28%高度
    },
    updateDays(index) {
      // 当数量变化时，自动更新天数
      const item = this.formParams.tableData[index];
      if (item && item.drugNumber) {
        const quantity = parseInt(item.drugNumber) || 1;

        // 获取接口返回的原始天数，如果没有则默认为7天
        const originalDays = item.originalDays || 7;

        // 计算天数：数量 × 接口返回的天数
        const calculatedDays = quantity * originalDays;
        item.days = Math.max(calculatedDays, 1); // 最少1天
      }
    },
  },
  updated() {
    // 组件更新后重新绑定拖拽事件并恢复保存的高度
    this.$nextTick(() => {
      this.bindFooterDragEvents();
      this.restoreFooterHeight();
    });
  },
  beforeDestroy() {
    let that = this;
    if (!that.lockReconnect) {
      that.lockReconnect = true;
      that.reconnectFlag = true;
      clearInterval(that.heartCheckStart);
      that.socket_init.close();
    }

    // 移除拖拽事件监听
    if (this.$refs.chatFooter) {
      this.$refs.chatFooter.$el.removeEventListener('mousedown', this._footerMouseDownHandler);
    }

    // 移除全局事件监听
    document.removeEventListener('mousemove', this.onFooterDrag);
    document.removeEventListener('mouseup', this.stopFooterDrag);

    // 确保清理拖拽状态
    if (this.isFooterDragging) {
      document.body.style.overflow = '';
      document.body.style.userSelect = '';
      document.body.classList.remove('dragging-footer');
    }
  },
  computed: {
    // 动态计算诊断表格高度
    getDiagnosisTableHeight() {
      const baseHeight = 40; // 表头高度
      const rowHeight = 50; // 每行高度
      const minHeight = 250; // 默认高度
      const maxHeight = 500; // 最大高度，避免过高

      const calculatedHeight = baseHeight + (this.prescriptionDiseInfoQOList.length * rowHeight);
      const finalHeight = Math.min(Math.max(calculatedHeight, minHeight), maxHeight);
      console.log('计算表格高度 - 诊断数量:', this.prescriptionDiseInfoQOList.length, '计算高度:', calculatedHeight, '最终高度:', finalHeight);
      return finalHeight;
    },

    isLogin() {
      return store.state.isLogin;
    },
    userInfo() {
      return store.state.userInfo;
    },
    userList() {
      return store.state.userList;
    },
    msgList() {
      //  左侧选择后应进入聊天页；
      // 接诊进行中（StatusFlag=true 且有订单号）也应显示；
      const orderNumber = store.state.orderNumber;
      const userInfo = store.state.userInfo;
      const statusFlag = store.state.StatusFlag;
      const showMsgFlag = store.state.showMsgFlag;

      if (showMsgFlag) return true;
      if (statusFlag && orderNumber && userInfo && userInfo.name) return true;
      return false;
    },
    getReload() {
      return store.state.setScrollFlag;
    },
    cf_flag() {
      return store.state.CF_Flag;
    },
    // 判断是否有弹窗显示
    hasDialogVisible() {
      return this.pre_FLag ||
          this.medicineDialog ||
          this.prescriptionDiseInfoQO ||
          this.refundVisible ||
          this.tipsFlag ||
          this.tipsFlag2;
    },
    // 判断是否为门诊中药饮片
    isTraditionalChineseMedicine() {
      return this.rxTypeCode === '2';
    },
    diagnosisNameLabel() {
      return this.diagType === '4' ? '证候名称' : '诊断名称';
    },
    diagnosisSearchPlaceholder() {
      return this.diagType === '4' ? '请输入要搜索的证候名称并回车搜索' : '请输入要搜索的诊断名称并回车搜索';
    },
    statusFlag() {
      return store.state.StatusFlag;
    },

    filteredSinDosuntOptions() {
      return (minPreparationUnit) => {
        if (!minPreparationUnit) {
          return this.sinDosuntOptions;
        }

        if (minPreparationUnit === "片") {
          return this.sinDosuntOptions.filter(option => option.value === "片");
        }

        if (minPreparationUnit === "粒") {
          return this.sinDosuntOptions.filter(option => option.value === "粒");
        }

        return this.sinDosuntOptions;
      };
    },
  },
};
</script>
<style scoped>
.choosed {
  border: solid 2px red;
}

/* 中药诊断样式 */
.last-item {
  border-bottom: none !important;
}

.login {
  width: 50%;
  margin-left: 25%;
  border: solid 1px rgb(228, 231, 237);
  padding: 30px;
}

.login .avatar {
  margin-top: 20px;
}

.login .avatar .el-avatar {
  cursor: pointer;
  margin-left: 5px;
}

.common {
  width: 100%;
  height: 100%;
  background: #f5f6fa;
}

.common .el-container {
  height: 98%;
  background: #f5f6fa;
}

.chatHeader,
.el-footer {
  background-color: #fff;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.chatHeader {
  padding: 9px 8px;
  height: 41px;
  border-right: 1px solid #00000017;
  text-align: left;
  line-height: 48px;
  padding-left: 10px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 18px;
  font-weight: 600;
  padding-right: 16px;
}

.el-aside {
  background: #f5f6fa;
  border-right: 1px solid #00000017;
  /* color: #333; */
  text-align: center;
}

.el-main {
  padding: 6px;
  padding-right: 0px;
  height: 70%;
  color: #333;
  background: rgb(245, 245, 245);
  overflow: hidden;
}

body > .el-container {
  margin-bottom: 40px;
}

.li_block {
  width: 300px;
  height: 30px;
  background: skyblue;
  margin-bottom: 5px;
}

.medicalBox {
  border-bottom: 1px black solid;
  background-color: #b3c0d1;
  font-size: 12px;
}

.medicalTxt {
  background-color: #fff;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.rightBox {
  position: relative;
  min-width: 50%;
}

.rightBoxHeader {
  position: absolute;
  top: 0;
  width: 97%;
  border-bottom: 1px solid gainsboro;
  padding: 9.5px 8px;
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  line-height: 40px;
  background-color: #fff;
  z-index: 2;
}

.rightBoxHeader div .el-input {
  margin-left: 8px;
  width: 60%;
}

.rightBoxMain {
  height: 100%;
  padding: 0px 10px;
  z-index: 1;
}

.rightTableBox {
  border: 1px 1px 0px 1px solid #000;
  background: #fff;
}

.rightTableBox div > span {
  position: relative;
  margin-right: 8px;
}

.rightBoxform {
  padding-left: 0;
}

.rightBoxform /deep/ .el-button {
  margin-top: 12px;
}

.textatraBox {
  position: relative;
}

.textatraBox > span {
  display: inline-block;
  padding-top: 4px;
  height: 24px;
}

.el-textarea > textarea {
  height: 40px;
}

.signature {
  display: flex;
  justify-content: space-between;
}

.rightBoxFooter {
  position: absolute;
  bottom: 0px;
  width: 96%;
  padding: 12px 8px;
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  z-index: 2;
}

.el-container .el-footer {
  height: 28% !important;
  border-top: 1px soild gainsboro;
}

.addButton {
  float: right;
}

::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}

::v-deep .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}

.el-dialog__header {
  color: #fff;
  background: linear-gradient(90deg, #36cdff 0%, #0f9bff 50%);
}

.el-dialog__header .el-dialog__title {
  color: #fff;
}

.el-dialog__header .el-dialog__headerbtn .el-icon-close {
  color: #fff;
}

.PRE_box /deep/ .el-dialog__body {
  background: #f5f6fa;
  padding: 12px 20px !important;
}

.numberInput {
  margin-right: 6px;
  display: inline-block;
  width: 48px;
}

.numberInput /deep/ .el-input__inner {
  width: 48px;
}

.upButton {
  margin: 0 auto;
  display: block;
  box-sizing: border-box;
  width: 180px;
  height: 48px;
  /* margin-top: 10px !important; */
}

.tipsMsgBox /deep/ .el-dialog__header {
  display: none;
}

.tipsMsgBox .el-dialog__header {
  display: none;
}

.tipsMsgBox /deep/ .el-dialog__body {
  background: #fff;
  color: #0caf60;
  text-align: center;
}

.tipsMsgBox .el-dialog__body {
  background: #fff;
  color: #0caf60;
  text-align: center;
}

.tableFormItem {
  margin-bottom: 0px;
}

/* 表格单元格对齐优化 */
.el-table .cell {
  display: flex;
  align-items: center;
  height: 100%;
}

/* 确保表格行高度一致 */
.el-table tbody tr {
  height: 48px;
}

/* 西药表格字段向上偏移10px */
.el-table .offset-column .cell {
  margin-bottom: 10px !important;
  padding-top: 0 !important;
}

.el-table tbody tr td {
  vertical-align: middle;
  padding: 8px 0;
}

/* 表格内选择框和输入框统一高度 */
.el-table .el-select,
.el-table .el-input {
  height: 40px;
}

.el-table .el-select .el-input__inner,
.el-table .el-input .el-input__inner {
  height: 40px;
  line-height: 40px;
}

/* 表格内按钮对齐 */
.el-table .el-button {
  vertical-align: middle;
  margin: 0;
}

.el-form-item /deep/ .el-form-item__content {line-height:39px !important;
}

.opsp_button {
  margin-left: 10px;
  padding: 8px 15px;
  background: #0caf60;
  font-size: 14px;
  line-height: 14px;
  color: #FFF;
  border: 0;
  cursor: pointer;
  border-radius: 8px;
}

.in_hospital_button {
  margin-left: 10px;
  padding: 8px 15px;
  background: #dadada;
  font-size: 14px;
  line-height: 14px;
  color: #FFF;
  border: 0;
  cursor: pointer;
  border-radius: 8px;
}

.statusIcon {
  margin-right: 8px;
  margin-bottom: 2px;
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  vertical-align: middle;
}

/* Footer拖拽样式 */
.chat-footer {
  position: relative;
  transition: height 0.1s ease;
  cursor: default;
  border-top: 2px solid transparent;
  /* 防止拖拽时影响其他元素 */
  touch-action: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* 鼠标悬浮时显示边框 */
.chat-footer:hover {
  border-top-color: transparent;
  cursor: default;
  /* 只在顶部命中区显示拖拽光标 */
}

/* 拖拽时的样式 */
.chat-footer.dragging {
  user-select: none;
  cursor: ns-resize;
  border-top-color: transparent;
  /* 防止拖拽时影响页面滚动 */
  pointer-events: auto;
}

/* 拖拽时禁用页面滚动，但保持footer可交互 */
.chat-footer.dragging ~ * {
  pointer-events: none;
}

/* 确保footer在拖拽时保持可交互 */
.chat-footer.dragging {
  pointer-events: auto !important;
}

.chat-footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 180px;
  right: 480px;
  height: 8px;
  cursor: ns-resize;
  z-index: 10;
  background-color: transparent;
  pointer-events: auto;
}

.drag-handle {
  position: absolute;
  top: 0;
  left: 180px;
  right: 480px;
  height: 8px;
  cursor: ns-resize;
  z-index: 100;
  background-color: transparent;
  pointer-events: auto;
}

/* 鼠标悬浮时显示拖拽指示器 */
.drag-handle:hover {
  /* 移除绿色指示器，保持透明 */
  background-color: transparent;
  border-top: none;
}

/* 鼠标悬浮时显示拖拽指示器 */
.chat-footer:hover::before {
  /* 移除绿色指示器，保持透明 */
  background-color: transparent;
  border-top: none;
}

/* 拖拽时禁用整个页面的滚动 */
body.dragging-footer {
  overflow: hidden !important;
  position: fixed;
  width: 100%;
  height: 100%;
}

/* 拖拽时禁用所有滚动容器 */
body.dragging-footer * {
  overflow: hidden !important;
}

/* 固定发送按钮到页面右下角 */
::v-deep .chat-footer .sendButton {
  position: absolute;
  right: 24px;
  bottom: -130px;
  z-index: 3000;
}

/* 小屏适配 */
@media (max-width: 768px) {
  ::v-deep .chat-footer .sendButton {
    right: 16px;
    bottom: 16px;
  }
}

.statusStyle,
.statusStyle1,
.statusStyle2,
.statusStyle3,
.statusStyle4 {
  line-height: 30px;
  padding: 1px 2px;
}

.statusStyle {
  color: red;
  border: 1px solid red;
}

.statusStyle1 {
  color: darkgray;
  border: 1px solid darkgray;
}

.statusStyle2 {
  color: darkorange;
  border: 1px solid darkorange;
}

.statusStyle3 {
  color: gold;
  border: 1px solid gold;
}

.statusStyle4 {
  color: lightgreen;
  border: 1px solid lightgreen;
}

/* 中药卡片样式 */
.chinese-medicine-cards {
  margin-bottom: 12px;
  min-height: 200px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
}

.empty-image {
  width: 180px;
  height: 180px;
  object-fit: contain;
}

.medicine-cards-container {
  display: flex;
  flex-wrap: wrap;
  gap: 9px;
  padding: 2px;
}

.medicine-card {
  position: relative;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  padding: 19px;
  min-width: 160px;
  max-width: 180px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.medicine-card:hover {
  border-color: #67c23a;
  box-shadow: 0 4px 8px rgba(103, 194, 58, 0.2);
}

.card-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 2px;
}

.medicine-info {
  flex: 1;
  min-width: 0;
}

.medicine-name {
  font-size: 13px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.medicine-code {
  font-size: 11px;
  color: #909399;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.medicine-price {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2px;
  font-size: 11px;
}

.price-label {
  color: #606266;
}

.price-value {
  color: #0caf60;
  font-weight: 500;
}

.medicine-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1px;
  font-size: 11px;
}

.total-label {
  color: #606266;
}

.total-value {
  color: #E6A23C;
  font-weight: 600;
}

.medicine-quantity {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 2px;
}

.quantity-label {
  font-size: 11px;
  color: #606266;
  width: 40px;
  text-align: left;
  flex-shrink: 0;
}

.quantity-input {
  width: 100px;
}

.quantity-input /deep/ .el-input__inner {
  text-align: center;
  padding: 0 8px;
}

.quantity-input-number {
  width: 100px;
}

.quantity-input-number /deep/ .el-input__inner {
  text-align: center;
  padding: 0 25px; 
  color: #303133; 
  background-color: #fff;
  height: 32px; 
  line-height: 32px;
  width: 100%; 
}

.quantity-input-number /deep/ .el-input-number__decrease,
.quantity-input-number /deep/ .el-input-number__increase {
   max-width: 20px;
}

.quantity-input-number /deep/ .el-input-number__handler-wrap {
  width: 20px;
}

.el-table .el-input-number {
  height: 32px;
}

.el-table .el-input-number /deep/ .el-input__inner {
  height: 32px;
  line-height: 32px;
  color: #303133;
}

.quantity-unit {
  display: inline-block;
  font-size: 12px;
  color: #606266;
  white-space: nowrap;
}

.medicine-remark {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 2px;
}

.remark-label {
  font-size: 11px;
  color: #606266;
  width: 40px;
  text-align: left;
  flex-shrink: 0;
}

.remark-select {
  width: 100px;
}

.card-actions {
  position: absolute;
  top: 0px !important;
  right: 0px !important;
}

.delete-btn {
  padding: 4px !important;
  color: #f56c6c !important;
  font-size: 16px !important;
}

.delete-btn:hover {
  color: #f78989 !important;
  background-color: #fef0f0 !important;
}
</style>